// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 767px) {

    body,
    html {
        font-size: 14px;
    }

    .personal-form h5 {
        font-size: 1.28rem;
    }

    .kuda-preview,
    .kuda-header--wrap,
    .kuda-layout---card,
    .auth-layout--header+.kuda-preview,
    .auth-wrap,
    footer .container {
        padding-left: 20px;
        padding-right: 20px;
    }

    .kuda-preview {
        padding-bottom: 35px;
    }

    .kuda-header {
        height: 64px;
        background: #fff;
        z-index: 100;
    }
    .kuda-header-hidden{
      z-index: 0;
    }

    .kuda-preview {
        display: block;
        padding-top: 40px;
    }

    h1 {
        font-size: 1.6rem;
    }

    .kuda-cta--table {
        max-width: 64px;
        height: 2px;
        padding-top: 2px;
        padding-bottom: 2px;
        width: 3px;
        font-size: 1px;
    }

    .kuda-cta--table span {
        /* max-width: 64px; */
        font-size: 10px;
    }

    .kuda-cta {
        font-size: 14px;
        height: 48px;
        width: 100%;
    }

    .kuda-account--summary .addAction {
        height: 44px;
    }

    .kuda-brand svg {
        height: 16px;
    }

    .denomination-icon svg {
        height: 9px;
        width: auto;
    }

    .balance-summary {
        height: 43px;
        margin-bottom: 1px;
    }

    .balance-title {
        margin-top: 0px;
    }

    .kuda-cta-lg {
        max-width: 240px;
    }

    .kuda-cta-long {
        max-width: 240px;
    }

    .text-xs {
        font-size: 0.78rem;
    }

    .kuda-account--summary .addAction {
        margin-bottom: 2px;
    }

    .budget-card {
        min-height: 76px;
    }

    .divider {
        width: auto;
    }

    .displayWrap>* {
        padding-left: 0px;
        padding-right: 0px;
    }

    .kuda-transaction--details {
        height: 100%;
    }

    .transaction-name {
        font-size: 12.3px;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden !important;
        text-overflow: ellipsis;
        width: calc(100%);
        margin-top: 0;
        -webkit-hyphens: auto;
        hyphens: auto;
    }

    .transaction-date {
        margin-top: 6px;
    }

    .kuda-transaction--tabs>li {
        font-size: 12px;
    }


    .auth-layout--header+.kuda-preview {
        align-items: flex-start;
    }

    .summary-card {
        width: 100%;
    }

    .back svg {
        margin-right: 6px;
        height: 11px;
        position: relative;
        /* top: -0.55px; */
    }
    .kuda-nav--icon-api{
        margin-top: 19px;
        margin-bottom: 20px;
        width: 100%;
    }
    .drop-icon{
        margin-top: 3px;
    }
    .drop-icon svg{
        height: 8px;
        width: 13px;

    }
    .api__mobile-menu-wrap{
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
    }
    .api__mobile-menu-text{
        display: flex;
        align-items: center;
    }
     .api__mobile-menu-text p{
        padding-top: 0px !important;
        padding-bottom: 0px !important;
     }
     .kuda-nav--icon-api-active p{
        color: #000000;
     }
    .kuda-layout---card .back {
        top: 25px;
        left: 20px;
    }

    .kuda-account {
        min-width: auto;
    }

    .account-title {
        display: none;
    }

    .kuda-inner--heading {
        font-size: 1.55rem;
    }

    .kuda-layout---card {
        padding-bottom: 30px;
    }

    .formCard {
        padding-left: 22px;
        padding-right: 22px;
        padding-bottom: 20px;
    }

    .kuda-deposit--wrap,
    .kuda-card--wrap,
    .payment-wrap .kuda-card--wrap,
    .payment-wrap .kuda-card--wrap.kuda-bill--wrap,
    .kuda-card--wrap.payment-wrap {
        padding-left: 22px !important;
        padding-right: 22px !important;
        padding-bottom: 40px !important;
    }

    .request-edge--fix>div {
        margin-left: -22px;
        margin-right: -22px;
        padding-left: 22px;
        padding-right: 22px;
    }

    .request-edge--fix .card-text {
        right: 22px;
    }

    .sign-out {
        margin-top: 30px;
    }

    .kuda-savings .kuda-card--wrap {
        padding: 40px 22px;
    }

    .kuda-heading--illustration svg {
        width: 86px;
        height: 86px;
    }

    .percentage-summary {
        min-height: 46px;
    }

    .kuda-preview {
        padding-top: 40px;
    }

    .kuda-add--cardForm {
        margin-bottom: 35px !important;
    }

    .bill-item--icon svg {
        height: 35px;
    }

    .bill-item {
        padding-left: 21px;
        padding-right: 21px;
        height: 54px;
    }

    .kuda-transaction--tabs {
        overflow-y: hidden;
        border-radius: 0;
        overflow-x: scroll;
        margin-top: 22px;
    }

    .kuda-payment--tabs li {
        min-width: 33.33%;
    }

    .payoneerTab li {
        min-width: 50%;
    }

    .percentage-save {
        height: 64px;
    }

    .balance.mt-5 {
        margin-top: 30px !important;
    }

    .percentage-toggle svg {
        height: 25px;
        width: auto;
    }

    .modal-backdrop {
        padding: 20px;
        margin-top: 0px;
    }

    .modal-content {
        padding-left: 25px;
        padding-right: 25px;
        padding-bottom: 40px;
    }

    .kuda-cta-md {
        max-width: 115px;
    }

    .transaction-title {
        margin-left: 15px;
    }

    .viewSavingsSummary .displayWrap>* {
        padding-left: 0px;
        padding-right: 0px;
    }

    .viewSavingsSummary .displayWrap>div>* {
        padding-left: 10px;
        padding-right: 10px;
    }

    .kuda-savings--header {
        margin-bottom: 40px !important;
    }

    .kuda-card--wrap {
        margin-top: 25px;
    }

    .member-profile {
        margin-right: 11px;
    }

    .kuda-account--wrap {
        margin-left: auto;
        margin-right: auto;
    }

    .kuda-account--summary>div,
    .kuda-block--nav {
        width: 100%;
    }

    .kuda-block--navWrapper {
        flex-direction: column;
    }

    .block-item {
        margin-bottom: 15px;
    }

    .kuda-bills--nav {
        margin-bottom: -23px;
    }

    .kuda-account--wrap {
        margin-left: auto;
        margin-right: auto;
        padding-left: 22px !important;
        padding-right: 22px !important;
    }

    .kuda-share--earn {
        margin-top: 30px;
    }

    .account-image {
        width: 85px;
        height: 85px;
        min-width: 85px;
        min-height: 85px;
    }

    .summary-labels {
        margin-left: 20px;
    }

    .kuda-invite--cta {
        font-size: 12px;
        height: 42px;
        margin-top: 15px;
    }

    .profile-account+.kuda-share--earn {
        margin-top: 33px !important;
    }

    .kuda-share--earn {
        padding-left: 21px;
        padding-right: 21px;
    }

    .block-item {
        padding: 10px 21px;
    }

    .earnings {
        font-size: 2rem;
    }

    .inactivity-buttons {
        flex-direction: column;
    }

    .inactivity-buttons>div {
        width: 100%;
        max-width: 100% !important;
        margin-bottom: 20px;
    }

    .transactionSummary .kuda-account--summary {
        width: auto !important;
        flex-direction: row;
    }

    .kuda-share--earn {
        flex-direction: column-reverse;
    }

    .kuda-invite--cta,
    .share-earn--50 {
        width: 100% !important;
    }

    .share-earn--50 * {
        text-align: center !important;
    }

    .earnings {
        justify-content: center;
    }

    .share-earn--50:last-child {
        margin-bottom: 15px;
    }

    .earned-amount {
        font-size: 2.5rem !important;
    }

    .kuda-account--wrap {
        padding-top: 80px !important;
    }

    .kuda-block--navWrapper h1 {
        text-align: center;
    }

    .home-account {
        padding-top: 35px !important;
    }

    .kuda-split--wrap .card-group {
        width: 100%;
    }

    .kuda-split--wrap {
        flex-direction: column;
        margin-bottom: 28px;
    }

    /* .edit-account--wrap {
        margin-top: 10px
    } */
    .back-to {
        left: 22px;
    }

    .kuda-cards .kuda-cta-lg {
        max-width: 100%;
    }

    .kuda-radio--wrapper {
        width: calc(50% - 10px);
    }

    .outer {
        width: 23px;
        height: 23px;
    }

    .inner {
        width: 11px;
        height: 11px;
    }

    .kuda-limit--pad {
        padding-left: 0;
        padding-right: 0;
    }

    .limit-fields>div {
        height: auto;
        padding-top: 14px;
        padding-bottom: 14px;
    }

    .kuda-prev span {
        line-height: 1.4;
    }

    .limit-fields .card-type,
    .limit-fields .card-text {
        line-height: 1.4;
    }

    .card-fields>div {
        align-items: flex-start !important;
    }

    .kuda-add--money .card-fields>div {
        align-items: center !important;
    }

    .panel__label span:first-child {
        padding-right: 30px;
    }

    .panel__label span {
        line-height: 1.45;
    }

    .kuda-margin--form .edit-account--wrap {
        margin-top: 0 !important;
    }

    .accordion {
        margin-top: 20px !important;
    }

    .share-header--wrap {
        flex-direction: column-reverse;
        margin-top: 0;
    }

    .share-header--wrap>* {
        width: 100% !important;
    }

    .kuda-auth--illustration {
        display: none !important;
    }

    .share-enty--text {
        margin-top: 30px;
    }

    .share-entry--content {
        margin-top: 20px;
    }

    .kuda-transaction--tabs::-webkit-scrollbar {
        display: none;
    }


    .kuda-account--summary .kuda-cta-lg {
        max-width: 115px !important;
    }

    .kuda-account--summary .addAction {
        margin-bottom: 0 !important;
    }

    .amount-input {
        font-size: 16px;
    }

    .transaction-price {
        font-size: 13px;
        margin-right: 12px;
    }

    .kuda-transaction--details {
        padding-right: 10px;
    }

    .kuda-search--field,
    .kuda-searchbox input {
        font-size: 16px;
    }

    .flex.justify-between .kuda-cta-md {
        max-width: calc(50% - 8px) !important;
    }

    .flex.justify-between .kuda-cta-lg-sm {
        max-width: calc(50% - 8px) !important;
    }

    .kuda-search--bank+.displayResults .kuda-result--item {
        padding-left: 10px;
        padding-right: 10px;
    }

    .card-check {
        margin-bottom: 35px;
    }

    .kuda-search--bank+.displayResults .kuda-result--heading {
        padding-left: 10px;
    }

    .withdrawButton {
        max-width: 120px;
        height: 46px;
        transform: none !important;
    }

    .card-fields+.accept {
        margin-top: 35px;
    }

    .percentage-save {
        margin-right: 12px;
    }

    .single-savings .singleTransaction .transaction-price {
        top: 4px !important;
    }

    .goal-actions .kuda-cta:not(:last-child) {
        margin-right: 15px;
    }

    .review-summary.card-fields>div {
        align-items: center !important;
    }

    .kuda-account--summary {
        margin-bottom: 30px;
    }

    .savedCard {
        width: 100%;
    }

    .empty-savings--card {
        padding-left: 20px;
        padding-right: 20px;
    }

    .kuda-set--status .addAction {
        max-width: 120px;
    }

    .kuda-set--status .addAction {
        max-width: 120px;
    }

    .referral-summary .transaction-name {
        overflow: auto;
        text-overflow: initial;
        white-space: normal;
    }

    .kuda-referral--card .empty-summary {
        padding-left: 0;
        padding-right: 0;
    }

    .kuda-referral--card .kuda-transaction--details,
    .kuda-referral--card .kuda-transaction--details .transaction-title {
        width: 100% !important;
        max-width: 100%;
        padding-right: 0;
    }

    .kuda-referral--card .kuda-result--heading {
        padding-left: 10px;
        padding-right: 10px;
    }

    .kuda-referral--card .kuda-result--item {
        width: 100% !important;
        padding-left: 10px;
        padding-right: 10px;
    }

    .skeleton-ui .balance-summary {
        height: auto;
    }

    .kuda-home-loader--wrap {
        margin-bottom: 21px;
    }

    .loader-30 {
        width: 50px;
    }

    .loader-30 span[style*="height: 52px"] {
        height: 50px !important;
    }

    .icons--kuda a:not(:last-child),
    .icons--kuda span:not(:last-child) {
        margin-right: 10px !important;
    }

    .socialIcon {
        margin-right: 10px !important;
    }

    .icons--kuda span {
        width: 44px;
        height: 44px;
    }

    .pin-input input {
        font-size: 16px !important;
    }

    .formInput {
        font-size: 16px !important;
    }

    .budget-heading--summary {
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 7px !important;
    }

    .kuda-budget--filter {
        flex-wrap: wrap;
    }

    .date-wrap {
        width: 100%;
        margin-bottom: 10px;
    }

    .filter-field {
        width: 100%;
    }

    .budget-heading--summary,
    .budget-card--header+.budget-heading--summary {
        margin-right: -20px;
        margin-left: -20px;
        overflow-x: scroll;
        margin-bottom: 20px;
    }

    .budget-card {
        min-width: calc(45% - 15px);
    }

    .budget-cards:before {
        padding-right: 20px !important;
        content: "";
        display: block;
    }

    .budget-cards:after {
        padding-right: 20px !important;
        content: "";
        display: block;
    }

    .category-budget .budget-cards:before,
    .budget-heading--summary .budget-cards:before {
        padding-right: 20px !important;
        content: "";
        display: block;
    }

    .category-budget .budget-cards:after,
    .budget-heading--summary .budget-cards:after {
        padding-right: 20px !important;
        content: "";
        display: block;
    }

    .budget-cards::-webkit-scrollbar {
        display: none;
    }

    .budget-cards {
        overflow-y: hidden;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        -webkit-overflow-scrolling: touch;
        scroll-snap-type: mandatory;
        scroll-snap-points-y: repeat(50%);
        scroll-snap-type: x mandatory;
        scroll-padding-left: 20px;
    }

    .budget-cards>* {
        scroll-snap-align: start !important;
        scroll-padding-left: 20px;
    }

    .category-budget .budget-heading--summary {
        margin-top: 0;
    }

    .budget-card--semiHeading {
        font-size: 0.85rem;
    }

    .budget-card:not(:last-child) {
        margin-right: 15px;
    }

    .DateRangePicker,
    .kuda-budget--filter .DateRangePickerInput {
        width: 100% !important;
    }

    .date-wrap .next-calendar--control:last-child {
        margin-right: 0 !important;
    }

    /*
    .DayPicker_portal__horizontal {
        width: 100%!important;
        transform: translateX(-50%);
        margin-left: 0!important;
    } */
    .budget-card .card-main--heading {
        font-size: 1.1rem;
    }

    .DayPicker_transitionContainer {
        min-height: 310px;
    }

    .kuda-budgeting .kuda-result--item {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    .kuda-budgeting:not(.category-budget) .transaction-price {
        height: 32px;
    }

    .kuda-budgeting:not(.category-budget) .transaction-name {
        margin-top: -3px;
        margin-bottom: 0px;
    }

    .kuda-item--chart .savings-progress {
        width: calc(100% - 55px);
    }

    .kuda-budget--excerpt .transaction-price {
        position: static;
    }

    .balance-icon {
        display: none;
    }

    .kuda-budget--excerpt .transaction-percentage {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 18px;
        width: 100%;
        text-align: left;
        padding-left: 64px;
    }

    .kuda-budget--excerpt {
        padding-bottom: 40px;
    }

    .budget-heading--summary,
    .budget-card--header .card-main--heading {
        margin-top: 25px;
    }

    .header-icon {
        display: flex;
    }

    .budgetTab {
        margin-top: 0 !important;
    }

    .budget-heading--summary {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    .budget-heading--summary::-webkit-scrollbar {
        display: none;
    }

    .budget-cards {
        padding-bottom: 15px;
    }

    .DateInput_input {
        width: 105px !important;
    }

    .kuda-wrap--wrap--holder>div {
        width: 100%;
        margin-bottom: 25px;
    }

    .kuda-wrap--wrap--holder {
        flex-wrap: wrap;
    }

    .kuda-wrap--wrap--holder {
        flex-wrap: wrap;
        padding-left: 20px;
        padding-right: 20px;
    }

    .history>div {
        width: 100%;
    }

    .history {
        flex-wrap: wrap;
    }

    .history-text {
        margin-bottom: 25px;
    }

    .kuda-history--items .kuda-transaction--tabs {
        margin-right: 0;
    }

    .budget-result--holder {
        margin-top: 26px;
    }

    .plan-budget--wrap svg.recharts-surface {
        margin-left: -38px !important;
        margin-top: -25px;
    }

    .plan-budget--wrap svg.recharts-surface {
        min-width: 220px;
    }

    .plan-budget--wrap .recharts-wrapper {
        margin-bottom: 20px;
    }

    .budgetTab+.tabs .kuda-search.kuda-search--bank {
        margin-top: 0;
    }

    .create-budget--modal {
        padding: 0;
    }

    .create-budget--modal .modal-content {
        margin: auto;
        height: auto;
        border-radius: 0;
        padding-bottom: 25px;
        padding-top: 33px;
    }

    .kuda-budget--form {
        height: calc(100vh - 306px) !important;
    }

    .backdrop-init .kuda-entry {
        overflow: hidden;
    }

    .edit--budget .kuda-cta {
        max-width: 100% !important;
    }

    .kuda-budget--form+.block-buttons {
        margin-top: 20px !important;
    }

    .kuda-wrap--wrap--holder:last-child {
        margin-top: -5px;
    }

    .kuda-wrap--wrap--holder:last-child {
        margin-top: -5px;
    }

    .category-budget .budget-cards:before,
    .category-budget .budget-cards:after {
        display: none;
    }

    .category-budget .budget-cards {
        margin-top: 25px;
        margin-bottom: 5px;
    }

    .edit--budget .kuda-cta:not(:last-child) {
        margin-right: 20px;
    }

    .kuda-dayLight--toggle {
        left: -30px;
    }

    .kuda-header--actions .kuda-dayLight--toggle {
        left: -35px;
    }

    .kuda-tran--items {
        max-width: 157px;
    }

    .kuda-tran--items .kuda-quick--statement {
        margin-bottom: 0;
    }

    .kuda-quick--statement svg {
        width: 32px;
        height: 32px;
    }

    .budget-create--bg svg {
        width: 48px;
        height: auto;
    }

    .budget-heading {
        font-size: 0.875rem;
    }

    .budget-create--bg {
        position: absolute;
        left: -18px;
        bottom: -20px;
    }

    .percentage-summary {
        top: 0;
    }

    .percentage-save {
        margin-bottom: 0 !important;
    }

    .kuda-page--loader {
        margin-left: 30px;
        margin-bottom: 40%;
    }

    .kuda-page--loader img,
    .kuda-page--loader svg {
        width: 190px !important;
        height: auto !important;
        margin-left: 0px;
    }

    .kuda-404--wrap {
        padding: 50px 40px 40px;
    }

    .coming-soon--downloads {
        flex-wrap: wrap;
        justify-content: space-between;
        max-width: 500px;
    }

    .coming-soon--downloads>* {
        width: calc(25% - 5px);
    }

    .coming-soon--downloads>* img {
        width: 100%;
        height: auto;
    }

    .account-skeleton .balance {
        margin-bottom: 20px;
    }

    .account-skeleton .balance-second--half {
        display: block;
    }

    .account-skeleton .kuda-account--summary {
        margin-bottom: 20px;
        flex-direction: column;
    }

    .account-skel--items .kuda-skeleton-span:last-child {
        display: none;
    }

    .kuda-footer--conditions p {
        font-size: 10.5px;
    }

    .category-budget .budget-heading--summary>div:after {
        padding-right: 20px !important;
        content: "";
        display: block;
    }

    .category-budget .budget-heading--summary>div:before {
        padding-left: 0px !important;
        content: "";
        display: block;
    }

    .account-skeleton .balance-icon {
        display: block !important;
        width: 65px;
        height: 65px;
        min-width: 65px;
    }

    .account-skeleton .balance.skeleton-ui>div:last-child span {
        width: 80% !important;
    }

    .denomination-icon {
        margin-right: 2px;
    }

    .kuda-header--wrap .kuda-cta {
        font-size: 14px;
        height: 42px;
        width: 150px;
    }

    .banks-ussd {
        margin-top: 28px;
        padding-bottom: 22px;
    }

    .kuda-form--ussd {
        margin-bottom: 0;
    }

    .addCard-skeleton {
        padding-top: 5px;
    }

    .plan-margin {
        margin-top: 8px;
    }

    .account-skeleton .balance {
        display: none !important;
    }

    .kuda-share--earnAlt {
        margin-top: 20px;
    }

    .share-header--wrap .kuda-share--earn {
        padding-bottom: 25px !important;
    }

    .linked-active {
        padding-bottom: 35px !important;
    }

    .add-product--wrap {
        margin-top: 10px;
    }

    .savedCards {
        margin-top: 10px;
    }

    .kuda-referral--card .edit-account--wrap {
        margin-top: 0;
    }

    .kuda-balance--wrap {
        width: 100%;
        min-height: 100%;
    }

    .payoneer-heading {
        margin-top: 30px;
        margin-bottom: 27px;
    }

    .revoke-content .kuda-modal-illustration svg,
    .kuda-budget--illustration svg {
        width: 65px !important;
        height: 65px !important;
    }

    .product-skeleton .kuda-account--summary>div {
        width: 100% !important;
    }

    .product-skeleton .kuda-account--summary {
        margin-bottom: 20px;
    }

    .savedCard {
        margin-bottom: 20px;
    }

    .kuda-share--earn {
        margin-top: 20px;
    }

    .addCard-skeleton {
        padding-top: 25px;
    }

    .kuda-account--wrap {
        padding-bottom: 25px !important;
    }

    .budget-card--header+.budget-heading--summary {
        margin-bottom: 0px !important;
    }

    .share-header--wrap .kuda-share--earn {
        padding-bottom: 30px !important;
    }

    .share-header--wrap .kuda-share--earnAlt {
        padding-bottom: 27px !important;
    }

    .justify-center.inactivity-buttons>div {
        max-width: 200px !important;
        margin-left: auto;
        margin-right: auto;
    }

    .kuda-announcement--card,
    .kuda-login--header {
        padding: 14px 20px;
    }

    .error-auth--label {
        padding: 12px 15px;
    }

    .auth-layout--header+.kuda-preview {
        min-height: calc(100vh - 88px) !important;
    }

    .kuda-page--transition .kuda-preview {
        min-height: calc(100vh - 80px);
    }

    .no-result {
        padding: 15px 5px 10px;
    }

    .request-wrap .kuda-cta-lg,
    .saveFields {
        max-width: 210px !important;
    }

    .saveFields {
        margin-top: 43px;
    }

    .back-to+.edit-account--wrap {
        margin-top: 0;
    }

    .linked-active .kuda-cta-lg {
        max-width: 175px;
    }

    .personal-form .login-button.kuda-cta-md {
        max-width: 170px !important;
    }

    .overdraftResults {
        margin-left: -22px;
        margin-right: -22px;
    }

    .overdraftResults>div>* {
        padding-left: 20px;
        padding-right: 20px;
    }

    .modal-overdraft .modal-content {
        max-width: 100% !important;
        height: 100vh;
    }

    .modal-overdraft .kuda-budget--form {
        height: calc(100vh - 170px) !important;
    }

    .backArrow {
        display: flex;
    }

    .backArrow svg {
        transform: translateY(-0.9px);
    }

    .card {
        width: 100px;
        height: 156px;
    }

    .active-card .card {
        transform: translate3d(-50px, 0, 0);
    }

    .active-card .card-secret-details {
        transform: translateX(0px);
    }

    .physical-card .flippy svg {
        width: 120px;
        height: 180px;

    }
    .active-card .flippy {
        transform: rotateY(-180deg) translate3d(0, 0, 0);
        -webkit-transform: rotateY(-180deg) translate3d(0, 0, 0);
        -moz-transform: rotateY(-180deg) translate3d(0, 0, 0);
        -ms-transform: rotateY(-180deg) translate3d(0, 0, 0);
        -o-transform: rotateY(-180deg) translate3d(0, 0, 0);
    }


    .card-animation--wrap,
    .physical-card>svg {
        height: 156px;
    }

    .new-card--illustration svg {
        max-width: 135px;
        height: auto;
    }

    .flex.justify-between>.kuda-cta-lg-md {
        width: calc(50% - 8px);
    }

    .upload-is--two {
        flex-direction: column;
    }

    .upload-item-md {
        width: 100% !important;
        max-width: 100%;
    }

    .modal-terms .kuda-radio--wrapper {
        width: 100%
    }

    .modal-terms .modal-content {
        max-height: calc(100vh);
        padding: 20px;
        border-radius: 0;
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        -ms-border-radius: 0;
        -o-border-radius: 0;
        max-width: 100%;
    }

    .kuda-terms--wrap {
        max-height: calc(100vh - 394px);
    }

    .form-group-row {
        flex-direction: column;
    }

    .form-group-row .card-group {
        width: 100%;
    }

    .form-group-row .card-group {
        margin-bottom: 22px !important;
        margin-top: 0 !important;
    }

    .form-group-row.mt-4 {
        margin-top: 0 !important
    }

    .form-fields {
        margin-top: 22px;
    }

    .mt-4.column--100 {
        margin-top: 0 !important;
    }

    .card-group {
        margin-bottom: 22px;
    }

    .card-group.mt-4 {
        margin-top: 0 !important;
    }

    .card-group .card-group {
        margin-bottom: 0 !important;
    }

    .onboarding-info--wrap>.mt-5:not(.justify-center) {
        margin-top: 1rem !important;
    }

    .block-item-wrap {
        padding-right: 10px;
    }

    .auth-header--full {
        max-width: 260px !important;
        margin-left: auto;
        margin-right: auto;
    }

    .bank-has--multiple---items .kuda-search {
        width: 100%;
        max-width: 100%;
        width: 100% !important;
        margin-bottom: 15px
    }

    .bank-has--multiple---items .tabs>.flex {
        flex-wrap: wrap;
        margin-bottom: -10px !important;
    }

    .toggleIcon {
        margin: 0
    }

    .toggleIcon:not(:last-child) {
        margin-right: 13px;
    }

    .toggleIcon {
        height: 48px;
        width: calc(33.33% - 41px)
    }

    .profile-account {
        margin-top: 35px;
    }

    .kuda-profile--center>.profile-account {
        margin-top: 0 !important;
    }

    .transaction-result--item,
    .kuda-result--heading {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    .other-items--wrap>.toggleIcon {
        width: 100%;
    }

    .other-items--wrap {
        width: 100%;
        overflow-x: scroll;
        padding-bottom: 10px;
        margin-bottom: 12px;
    }

    .onboarding-info--wrap .flex-wrap.flex {
        flex-direction: column;
    }

    .kuda-tiny--button {
        min-width: 50px;
    }

    .column--50 {
        width: 100%;
    }

    .kin-wrap .form-group-row.mt-4 {
        margin-top: 23px !important;
    }

    .card-display--bio {
        padding: 15px 20px !important;
    }

    .onboarding-info--wrap .flex-wrap.flex>.column--50 {
        margin-bottom: 10px;
        margin-top: 0 !important;
    }

    .has-bottom--spacing {
        margin-bottom: 20px;
    }

    .mobile-input>.card-group {
        margin-bottom: 0;
    }

    .kuda-login--wrap>*+.auth-wrap,
    .kuda-started--container *+.kuda-login--wrap .auth-wrap {
        padding-top: 80px
    }

    .block-item-sm .add-signatory--wrap.block-item {
        width: 100% !important;
        max-width: 175px;
    }

    .auth-wrap .empty-summary {
        margin-top: 0;
    }

    .kuda-started--container .kuda-auth--layout {
        margin-top: 0
    }

    .kuda-announcement--card h1 {
        font-size: 2.2rem !important;
    }

    .kuda-login--header {
        padding-top: 0 !important;
    }

    .tr.table-row--border td:nth-child(1),
    table.kuda-signatory--table thead tr th:nth-child(1) {
        min-width: 260px;
    }

    .tr.table-row--border td:nth-child(2),
    table.kuda-signatory--table thead tr th:nth-child(2) {
        min-width: 152px;
    }

    .tr.table-row--border td:nth-child(3),
    table.kuda-signatory--table thead tr th:nth-child(3) {
        min-width: 152px;
    }

    .tr.table-row--border td:nth-child(4),
    table.kuda-signatory--table thead tr th:nth-child(4) {
        min-width: 120px;
    }

    .request-payment {
        display: block;
        min-width: 190px;
        max-width: 190px;
        width: 190px;
    }

    .kuda-payment--item---wrap>* {
        padding-left: 10px;
        padding-right: 10px;
    }

    .kuda-payment--item---wrap.overflow-x-scroll div.kuda-result--heading {
        width: fit-content;
    }

    .sme-m-info--card {
        flex-direction: column;
    }

    .sme-m-info--card>ul {
        width: 100%;
        margin-bottom: 20px;
    }

    .sme-m-info--card>ul:last-of-type {
        margin-bottom: 0;
    }

    .sme-info--card .vertical-divider {
        width: 100%;
        height: 1px;
        background-color: var(--blackColor);
        margin: 0 0 20px 0;
    }

    .document-is--sided {
        margin-top: 40px;
        flex-direction: column;
        margin-right: 0;
    }

    .document-is--sided>div {
        width: 100%;
        margin-right: 0;
    }

    .inline-sample--wrap:before {
        left: 50%;
        transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        -o-transform: translateX(-50%);
        width: 1px;
        height: 2rem;
        top: calc(-2rem - 1px);
    }

    .company-mini-profile {
        flex-direction: column;
        margin-bottom: 0px !important;
    }

    .company-mini-info {
        margin-bottom: 1.5rem !important;
        align-items: flex-start !important;
        width: 100% !important;
    }

    .summary-labels-mb {
        margin-top: 15px
    }

    .business-img-file-input {
        position: absolute !important;
        top: 70px !important;
        left: 120px !important;
        right: 0;
        bottom: 0;
        width: 100px;
        height: 100px;
        opacity: 0;
        cursor: pointer;
        z-index: 9;
    }

    .mobile-mt-4 {
        margin-top: 23px !important;
    }

    .edit-to {
        position: absolute;
        font-size: 12px;
        display: flex;
        align-items: center;
        top: 25px;
        right: 0px !important;
        cursor: pointer;
    }

    .kuda-terms--tab {
        margin-left: 0 !important;
        margin-right: 0 !important
    }

    .edit-moreOptions--wrap .kuda-select--radio {
        height: 44px;
    }

    .modal-terms {
        padding: 0 !important;
    }

    .content-wrap {
        padding-bottom: 20px;
    }

    .kuda-get--app .kuda-signup--wrap {
        margin: 0 auto;
        padding: 0 !important;
    }

    .kuda-get--app {
        transform: none !important;
        margin-top: 0;
        padding-top: 40px;
    }

    .kuda-get--app.align-center {
        align-items: flex-start !important;
    }

    .kuda-get--app .kuda-signup--wrap .kuda-signup--right {
        display: none;
    }

    .kuda-signup--left {
        padding: 40px 30px 45px;
    }

    .kuda-signup--left * {
        text-align: center;
        justify-content: center;
    }

    .c-apps+div {
        margin-top: 13px !important;
    }

    .kuda-reports--radio {
        flex-direction: column;
    }

    .kuda-reports--radio .radio-height--md {
        width: 100%;
        max-width: 100%;
    }

    .export-modal .modal-content {
        padding-left: 25px;
        padding-right: 25px;
        padding-bottom: 40px;
    }

    .kuda-reports--radio .radio-height--md.mr-3 {
        margin-bottom: 15px;
    }

    .header-bottom--spacing {
        margin-bottom: 23px
    }

    .kuda-preview {
        margin-top: 64px;
    }

    .restricted-account--wrap {
        padding: 20px;
        position: relative;
        overflow: hidden;
    }

    .restricted-account--wrap .restricted-image--wrap {
        position: absolute;
        right: -180px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
    }

    .restricted-account--wrap .restricted-text {
        padding-bottom: 0 !important;
        padding-right: 72px;
    }
    .tr.table-row--border td:nth-child(1),.bulk-payment table.kuda-signatory--table thead tr th:nth-child(1) {
        min-width: fit-content;
    }
    .overflow-x-scroll-mobile {
        overflow-x: scroll;
    }
}

@media only screen and (max-width: 1153px){
    .kuda-nav--icon a{
        margin-right: 25px;
    }
}

@media only screen and (max-width: 375px) {
    .kuda-header--wrap .kuda-cta {
        font-size: 13px;
        width: 140px;
    }

    .kuda-header--actions .kuda-dayLight--toggle {
        left: -33px;
    }

    .phoneInput {
        font-size: 16px !important;
    }
}

 @media only screen and (max-width: 320px) {
    .kuda-header--wrap .kuda-cta {
        font-size: 12px;
        width: 131px;
        margin-top: 15px;
    }

    .auth-layout--header {
        height: 110px;
    }

    .auth-layout--header .kuda-header--wrap {
        flex-direction: column;
        align-items: start !important;
    }

    .auth-layout--header .kuda-header--actions .kuda-dayLight--toggle {
        left: auto;
        right: 20px;
        top: 17px;
    }

    .auth-layout--header .kuda-header--actions {
        position: static;
    }

    .auth-layout--header+.kuda-preview {
        margin-top: 115px;
    }

    .auth-layout--header+.kuda-preview {
        min-height: calc(100vh - 135px) !important;
    }

    .kuda-header--actions {
        width: 100%;
    }

    .kuda-header--wrap .kuda-cta {
        max-width: 100%;
    }
}

@media only screen and (min-width: 768px) and (max-width: 924px) {
    html {
        font-size: 14.5px;
    }

    .kuda-nav--icon a,
    .kuda-nav--icon p {
        margin-right: 34px;
    }

    .kuda-nav--icon svg {
        width: 19px;
    }

    .kuda-dayLight--toggle svg {
        width: 18px;
    }

    .kuda-dayLight--toggle {
        left: -30px;
    }

    .kuda-header--wrap,
    footer .container {
        padding-left: 40px;
        padding-right: 40px;
    }

    .kuda-brand svg {
        height: 18px;
        width: auto;
    }

    .kuda-payments .card-summary-text p {
        font-size: 15px;
    }

    .percentage-save {
        margin-right: 12px;
    }

    .kuda-skeleton-span+.budget-heading--summary {
        margin-bottom: 45px;
    }
}

@media only screen and (max-width: 1136px){
.kuda-started--container {
    max-width: 700px;
}
}
@media only screen and (max-width: 923px){
    .kuda-nav--icon a{
        margin-right: 25px;
    }
}

@media only screen and (max-width: 575px) {
    .kuda-transaction--tabs {
        overflow-y: hidden;
        margin-left: -20px;
        margin-right: -20px;
    }

    .account-skeleton span.mb-2.bottom>span>span {
        width: 100% !important;
    }

    .account-skeleton span.mb-2.bottom {
        width: 100%;
    }

    .account-skeleton .balance-summary {
        width: 100%;
    }

    .budget-heading--summary .category-budget--highlighted .card-main--heading {
        line-height: 1.4;
        position: relative;
        top: -2px;
    }

    .budget-card .card-main--heading {
        font-size: 1rem;
    }

    .kuda-auth--illustration {
        display: none;
    }

    .kuda-auth--wrap {
        max-width: 100%;
    }

    .block-item--icon {
        display: none !important;
    }

    .kuda-payment--tabs li {
        min-width: 30% !important;
    }

    .signup-form--wrap {
        max-width: 100%;
        width: 100%;
        flex-direction: column;
    }

    .auth-wrap {
        flex-direction: column;
    }

    .account-setup--right {
        display: none;
    }

    .login-container--wrap {
        background-size: auto !important;
    }
}

@media only screen and (min-width: 768px) {
    .kuda-header{
        display: none !important;
    }

    .kuda-auth--illustration svg {
        min-width: 700px;
    }

    .kuda-search--bank+.displayResults .displayWrap>* {
        padding-left: 0px;
        padding-right: 0px;
    }

    .kuda-search--bank+.displayResults .kuda-result--item {
        padding-left: 30px;
        padding-right: 30px;
    }

    .kuda-search--bank+.displayResults .kuda-result--heading {
        padding-left: 31px;
    }

    .transaction-left {
        padding-right: 15px;
    }

    .account-title.active {
        position: relative;
    }

    .account-title.active:after {
        content: "";
        display: block;
        height: 5px;
        bottom: 0px;
        position: absolute;
        background: #000000;
        width: 100%;
    }

    .earnings {
        line-height: 1;
        margin-top: 8px;
        margin-bottom: -7px;
    }

    .transaction-name {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden !important;
        text-overflow: ellipsis;
        width: calc(100%);
        -webkit-hyphens: auto;
        hyphens: auto;
        padding-right: 40px;
        line-height: 1.2;
    }

    .no-bottom--margin-desktop {
        margin-bottom: 0 !important;
    }

    .skeleton-card--top .kuda-card--wrap {
        padding-bottom: 57px !important;
    }

    .plan-margin {
        margin-top: 8px;
    }

    .kuda-add--active .kuda-preview {
        max-width: 959px;
    }

    .kuda-add--active .kuda-add--options {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
    }

    .kuda-add--active .kuda-add--options>* {
        width: calc(50% - 10px);
        max-width: 100%;
        margin-right: 0;
        margin-left: 0;
    }

    .account-image {
        margin-top: -4px;
    }

    .kuda-signup--wrap {
        max-height: 605px;
    }

    .kuda-started--container .react-datepicker-popper {
        z-index: 99 !important;
        min-width: 360px;
    }

    .kuda-started--container .onboarding-info--wrap .react-datepicker__day-name,
    .kuda-started--container .onboarding-info--wrap .react-datepicker__day,
    .kuda-started--container .onboarding-info--wrap .react-datepicker__time-name {
        width: 12% !important;
    }

    .upload-is--two .upload-item {
        width: calc(50% - 8px);
        max-width: 100%;
    }

    .upload-is--two {
        justify-content: space-between;
    }

    .mt-4-md {
        margin-top: 1.5rem;
    }

    .mobile-input>.card-group {
        margin-bottom: 0;
    }

    .document-is--sided .mt-4.flex.justify-center {
        margin-top: 0 !important;
    }

    .document-is--sided .upload-item {
        margin-top: 20px;
    }

    .inventory-search-toggle--icon {
        margin-top: 23px !important;
    }

    .form-group-row .card-group .react-datepicker,
    .form-group-row .card-group .react-datepicker__month-container {
        min-width: 340px;
        max-width: 340px;
    }
}

@media only screen and (max-width: 1200px) {
    .auth-layout-wrap>div:last-child {
        width: calc(100% - 420px);
    }

    .auth-layout--header+.kuda-preview {
        min-height: calc(100vh - 100px);
    }
}

@media only screen and (max-width: 320px) {

    html,
    body {
        font-size: 13px;
    }

    .kuda-preview,
    .kuda-header--wrap,
    .kuda-layout---card,
    .auth-layout--header+.kuda-preview,
    .auth-wrap,
    .modal-content,
    footer .container {
        padding-left: 14px;
        padding-right: 14px;
    }

    .kuda-cta {
        font-size: 13px;
        height: 44px;
    }

    .kuda-transaction--details {
        padding-right: 10px;
    }

    .single-savings .transaction-name {
        padding-right: 10px;
    }

    .summary-card {
        padding: 20px 15px 32px;
    }

    .modal-content {
        padding-top: 25px;
        padding-bottom: 25px;
    }

    .kuda-budget--form {
        height: calc(100vh - 298px) !important;
    }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
    .kuda-account--wrap {
        max-width: 100%;
        padding: 40px 30px !important;
    }

    .kuda-block--nav {
        width: calc(50% - 10px);
    }

    .earn-heading {
        font-size: 0.875rem;
    }

    .earnings {
        margin-bottom: 3px;
    }

    .balance:not(.home-skel) .balance.skeleton-ui>div:last-child span {
        width: 100% !important;
    }

    .balance:not(.home-skel) .balance.skeleton-ui>div:last-child {
        width: 100% !important;
    }

    .kuda-add--active .kuda-layout---card {
        padding-left: 30px !important;
        padding-right: 30px !important;
    }


}

@media only screen and (min-width: 768px){
    .kuda-account--wrap {
         margin-left: 0px;
        margin-right: 0px;
    }
}
/* @media only screen and (min-width: 858px){
       .kuda-account--wrap {
         margin-left: -65px;
        margin-right: -65px;
    }
} */
@media only screen and (min-width: 1150px){
       .kuda-account--wrap {
         margin-left: auto;
        margin-right: auto;
        margin-top: 48px;
    }
}
@media only screen and (max-height: 760px) {
    .modal-backdrop {
        /* display: block; */
        overflow-y: auto;
    }

    .modal>.modal {
        display: flex;
    }

    .modal-backdrop .modal-content {
        margin: auto;
    }
}

@media only screen and (min-width: 481px) and (max-width: 767px) {
    .kuda-auth--illustration svg {
        min-width: 700px;
    }

    .auth-layout-wrap>div:last-child {
        width: calc(100% - 530px);
    }
}

@media only screen and (min-width: 1025px) and (max-width: 1199px) {
    .budget-heading--summary {
        margin-right: -140px !important;
        margin-left: -140px !important;
    }

    .budget-heading--summary .card-main--heading {
        font-size: 1.15rem !important;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .kuda-auth--illustration {
        display: none;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .budget-heading--summary {
        margin-right: -70px !important;
        margin-left: -70px !important;
        flex-wrap: wrap;
    }

    .budget-card {
        min-width: calc(25% - 20px);
        margin-bottom: 20px;
    }

    .budget-cards {
        margin-bottom: -20px !important;
    }

    .budget-skeleton .budget-cards {
        margin-bottom: 0px;
    }

    .budget-card:not(:last-child) {
        margin-right: 12px;
    }

    .budget-card {
        min-height: 100%;
    }

    .budget-card--semiHeading {
        font-size: 0.8rem;
    }

    .card-main--heading {
        font-size: 1.1rem;
    }

    .kuda-budget--filter .DateRangePickerInput {
        width: 308px !important;
    }

    .kuda-wrap--wrap--holder>div {
        width: 100%;
    }

    .kuda-wrap--wrap--holder>div:not(:last-child) {
        margin-bottom: 25px;
    }
}

@media only screen and (max-width: 375px) {
    .budget-card {
        min-width: calc(70% - 15px);
    }
}

@media only screen and (max-width: 400px) {
    .DateInput_input {
        width: 100% !important;
    }

    .DateInput_input {
        padding-left: 5px;
        font-size: 0.9rem !important;
    }
}

@media only screen and (max-width: 375px) {

    body,
    html {
        font-size: 13px;
    }

    .balance-summary {
        height: 41px;
    }
}

@media only screen and (max-height: 800px) and (min-width: 1025px) and (max-width: 1366px) {

    html,
    body {
        font-size: 14.8px;
    }

    .kuda-preview {
        padding: 48px 40px 60px;
    }

    .balance-title {
        margin-top: 6px;
    }

    .kuda-transaction--tabs {
        margin-top: 30px;
    }
}

@media only screen and (max-width: 991px) {
    .invoice-f-col {
        min-width: 300px !important;
        max-width: 300px !important;
        width: 300px !important;
    }
}

@media only screen and (max-width: 409px) {
    .homeSkel {
        width: calc(50% - 7px) !important;
    }

    .homeSkel .balance-summary {
        width: 100%;
    }

    .homeSkel .balance-summary span,
    .homeSkel+span span {
        width: 100% !important;
    }

    .homeSkel .balance-summary>span:first-child {
        width: 65% !important;
    }

    .homeSkel+span {
        width: calc(50% - 7px) !important;
    }
}

@media only screen and (max-width: 350px) {
    .kuda-cta {
        font-size: 13px;
        height: 46px;
    }

    h1 {
        font-size: 1.4rem;
    }

    .denomination-icon svg {
        height: 8px;
        width: auto;
    }

    .balance-summary {
        height: 39px;
    }

    .kuda-quick--statement svg {
        width: 30px;
        height: 30px;
        margin-right: 6px;
    }

    .kuda-account--summary .kuda-cta-lg {
        max-width: 105px !important;
        min-width: 105px !important;
    }

    .kuda-tran--items {
        max-width: 142px;
    }

    .balance-summary {
        margin-bottom: 3px;
    }

    .kuda-header--wrap .kuda-cta {
        font-size: 13px;
        height: 42px;
        width: 100%;
    }
}

@media only screen and (max-height: 798px) and (min-width: 1140px) {
    .kuda-cta {
        font-size: 15px;
    }

    .kuda-cta-md {
        max-width: 150px;
    }
}

@media only screen and (min-height: 799px) and (min-width: 768px) {
    .kuda-auth--illustration svg {
        min-width: 820px;
    }

    .justify-between>.kuda-cta-md {
        max-width: 150px;
    }
}

@media only screen and (min-height: 799px) and (min-width: 768px) and (max-width: 1280px) {
    .kuda-auth--illustration svg {
        min-width: 750px;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1300px) {
    .kuda-auth--wrap {
        max-width: 410px;
        width: 100%;
    }

    .auth-wrap {
        padding: 50px 70px 30px;
    }

    .kuda-form--layout {
        margin-top: 25px;
    }

    .kuda-auth--wrap p {
        font-size: 0.9rem;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1300px) and (min-height: 799px) {
    .auth-layout-wrap>div:last-child {
        width: calc(100% - 475px);
    }

    .edit-moreOptions--wrap .kuda-select--radio {
        height: 44px;
    }

    .kuda-select--radio {
        margin-top: 15px;
    }

    .kuda-terms--wrap {
        max-height: calc(100vh - 508px);
    }

    .modal-terms .modal-content {
        max-height: calc(100vh - 80px);
    }
}

@media only screen and (min-width: 768px) and (max-width: 1440px) and (max-height: 798px) {
    .container {
        max-width: 720px;
    }

    .payments-container {
        max-width: 850px;
    }

    .kuda-signup--container {
        max-width: 957px !important;
    }

    .modal-content {
        padding: 35px 48px 48px;
    }

    html,
    body {
        font-size: 14px !important;
    }

    .fund-card--modal .modal-content {
        max-width: 410px;
    }

    .kuda-cta {
        font-size: 14px;
        height: 45px;
    }

    .kuda-header--wrap .kuda-cta {
        font-size: 13.5px;
        height: 43px;
    }

    .kuda-result--item {
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .kuda-search--field,
    .kuda-transaction--tabs {
        height: 47px !important;
    }

    .kuda-terms--tab {
        height: 25px !important;
        min-height: 35px;
    }

    .kuda-transaction--details {
        height: 37px;
    }

    .transaction-icon {
        width: 40px;
        height: 40px;
        min-width: 40px;
    }

    .kuda-nav--icon svg {
        width: 23px;
    }

    .kuda-preview {
        padding: 48px 40px 60px;
    }

    .balance-title {
        margin-top: 6px;
    }

    .kuda-transaction--tabs {
        margin-top: 30px;
    }

    .kuda-account--summary {
        margin-bottom: 30px;
    }

    .budgetTab {
        margin-top: 0;
    }

    .payment-wrap .kuda-card--wrap {
        max-width: 480px;
    }

    .amount-input {
        min-height: 44px;
    }

    .card-group:not(:last-child) {
        margin-bottom: 24px;
    }

    .kuda-dropdown-header {
        height: 44px;
    }

    .kuda-add--cardForm {
        margin-bottom: 44px;
    }

    .card-label {
        font-size: 13px;
    }

    .add-amount {
        margin-top: 10px;
    }

    .kuda-searchbox {
        padding: 4px 15px;
    }

    .kuda-dropdown-list {
        padding-top: 48px;
    }

    .kuda-dropdown-item {
        padding: 13px 0 12px !important;
    }

    .payment-wrap .kuda-card--wrap.kuda-bill--wrap {
        padding-left: 65px;
        padding-right: 65px;
    }

    .bill-item,
    .block-item {
        height: 52px;
    }

    .kuda-account--wrap {
        padding: 45px 62px 40px !important;
    }

    .kuda-invite--cta {
        font-size: 11px;
        height: 20px;
    }

    .kuda-header {
        height: 65px;
    }

    .kuda-preview {
        margin-top: 65px;
    }

    .account-title.active:after {
        bottom: -15px;
    }

    .referral-icon svg {
        height: 88px;
        width: auto;
    }

    .toggle-icon {
        width: 50px;
        border-radius: 16px;
        height: 28px;
    }

    .toggle-icon:after {
        height: 20px;
        width: 20px;
        top: 4px;
        left: 4px;
    }

    .has-checkBox .toggle {
        top: -4px;
        right: 8px;
    }

    .bill-item--icon svg,
    .block-item--icon svg {
        height: 28px;
    }

    .bill-item--icon {
        margin-right: 15px;
    }

    .block-item--icon {
        margin-right: 10px;
    }

    .account-image {
        width: 85px;
        height: 85px;
        min-width: 85px;
        min-height: 85px;
    }

    .toggle input[type="checkbox"]:checked+.toggle-icon:after {
        transform: translateX(22px);
    }

    .kuda-brand svg {
        height: 18px;
        width: auto;
    }

    .kuda-add--options>* {
        max-width: 330px;
    }

    .kuda-deposit--wrap,
    .kuda-card--wrap {
        max-width: 380px;
    }

    .accept {
        margin: 38px 0 0;
    }

    .bottom-fix {
        margin-bottom: 30px;
    }

    .kuda-budgeting:not(.category-budget) .transaction-price {
        height: 34px;
    }

    .kuda-budget--filter .DateRangePickerInput {
        height: 46px;
    }

    .kuda-calendar--control {
        min-height: 46px;
    }

    .plan-budget--wrap {
        max-width: 100%;
    }

    .overview-budget--wrap {
        max-width: 100%;
    }

    footer {
        margin-top: 60px;
    }

    .notice-modal {
        max-width: 390px !important;
    }

    .small-modal .modal-content {
        max-width: 410px;
    }

    .export-modal .modal-content {
        max-width: 485px;
    }

    .kuda-footer--conditions p {
        font-size: 10.5px;
    }

    footer .container {
        max-width: 1050px;
    }

    .inactivity-buttons .kuda-cta-lg {
        max-width: 146px;
    }

    .kuda-auth--wrap {
        max-width: 370px;
    }

    .auth-layout-wrap>div:last-child {
        width: calc(100% - 450px);
    }

    .auth-wrap {
        padding: 50px 70px 30px;
    }

    .basic-dropdown {
        padding-top: 2px;
    }

    .kuda-page--loader img,
    .kuda-page--loader svg {
        width: 190px !important;
    }

    .kuda-modal-illustration {
        margin: 35px auto 30px;
    }

    .modal-transactions .modal-content {
        max-width: 470px;
    }

    .payment-bold--wrap {
        max-width: 240px;
    }

    .forgot-label {
        font-size: 11.5px;
    }

    .single-timeline {
        margin-bottom: 40px;
    }

    .kuda-cta-lg {
        max-width: 142px;
    }

    .kuda-tran--items {
        max-width: 192px;
    }

    .balance-summary h1.text-xbold.flex {
        position: relative;
        top: -2px;
    }

    .kuda-login--wrap .formInput {
        font-size: 14.5px;
    }

    .kuda-home-loader--wrap:last-child {
        display: none;
    }

    .create-budget--modal .modal-content {
        height: calc(100vh - 115px);
    }

    .create-budget--modal .modal-content {
        max-width: 550px !important;
    }

    .kuda-budget--form {
        height: calc(100vh - 420px) !important;
    }

    .create-budget--modal .createBalance {
        height: 40px;
    }

    .create-budget--modal .kuda-result--heading {
        margin-top: 25px;
    }

    .kuda-budget--filter .DateRangePickerInput {
        width: 300px !important;
    }

    .filter-field {
        width: calc(100% - 251px);
    }

    .DateInput_input {
        width: 103px !important;
        padding-left: 9px;
        padding-top: 9px;
    }

    .CalendarMonth_caption {
        padding-top: 17px;
    }

    .budget-heading--summary {
        margin-right: -195px;
        margin-left: -195px;
    }

    .create-budget--button {
        max-width: 170px !important;
    }

    .form-loading:after {
        width: 27px;
        height: 27px;
        background-size: 27px 27px;
    }

    .inputLoading:after {
        width: 24px;
        height: 24px;
        background-size: 24px 24px;
    }

    .skeleton-card--top .kuda-activate--wrap {
        max-width: 420px;
        padding-left: 50px !important;
        padding-right: 50px !important;
    }

    .payoneer-modal .modal-content {
        max-width: 380px !important;
    }

    .kuda-balance--wrap .add-icon {
        margin-bottom: 9px;
    }

    .kuda-balance--wrap {
        min-height: 140px;
    }

    .payoneer-modal-heading {
        margin-top: 1.7rem;
        margin-bottom: 1.7rem;
    }

    .payoneer-modal .generateReceipt {
        max-width: 195px;
    }

    .kuda-add--active .kuda-preview {
        max-width: 860px;
    }

    .closeModal svg {
        height: 24px;
    }

    /* .closeModal {
        top: -18px;
    } */
    .payoneer-heading {
        max-width: 315px;
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .kuda-cta-long {
        width: 100%;
        max-width: 208px;
    }

    .kuda-dropdown-list {
        max-height: 320px;
    }

    .kuda-cta-xl {
        max-width: 210px;
    }

    .product-skeleton .kuda-account--summary {
        margin-bottom: 20px;
    }

    .kuda-auth--wrap p {
        font-size: 0.845rem;
    }

    .kuda-auth--illustration svg {
        max-height: 520px;
    }

    .kuda-header--wrap .kuda-cta {
        width: 158px;
        max-width: 158px;
    }

    .edit-moreOptions--wrap .kuda-select--radio {
        height: 44px;
    }

    .kuda-select--radio {
        margin-top: 15px;
    }

    .kuda-terms--wrap {
        max-height: calc(100vh - 485px);
    }

    .modal-terms .modal-content {
        max-height: calc(100vh - 80px);
    }
}

@media only screen and (min-width: 768px) and (max-width: 1280px) and (max-height: 698px) {
    .container {
        max-width: 640px;
    }

    .transaction-header {
        margin-top: 25px;
        margin-bottom: 15px;
    }

    .modal-content {
        padding: 30px 43px 43px;
    }

    html,
    body {
        font-size: 12.5px !important;
    }

    .fund-card--modal .modal-content {
        max-width: 390px;
    }

    .kuda-cta {
        font-size: 12.5px;
        height: 42px;
    }

    .formCard,
    .kuda-deposit--wrap,
    .kuda-card--wrap {
        max-width: 330px;
    }

    .kuda-result--item {
        padding-top: 14px;
        padding-bottom: 14px;
    }

    .kuda-search--field,
    .kuda-transaction--tabs {
        height: 44px !important;
        min-height: 44px !important;
    }

    .kuda-transaction--details {
        height: 33px;
    }

    .transaction-icon {
        width: 40px;
        height: 40px;
        min-width: 40px;
    }

    .kuda-nav--icon svg {
        width: 20px;
    }

    .kuda-preview {
        padding: 40px 40px 55px;
    }

    .balance-title {
        margin-top: 8px;
    }

    .kuda-transaction--tabs {
        margin-top: 30px;
    }

    .kuda-account--summary {
        margin-bottom: 30px;
    }

    .budgetTab {
        margin-top: 0;
    }

    .payment-wrap .kuda-card--wrap {
        margin-top: 30px;
        padding-left: 46px;
        max-width: 420px;
        padding-right: 46px;
        padding-bottom: 36px;
    }

    .amount-input {
        min-height: 40px;
    }

    .card-group:not(:last-child) {
        margin-bottom: 24px;
    }

    .kuda-dropdown-header {
        height: 40px;
    }

    .kuda-add--cardForm {
        margin-bottom: 40px;
    }

    .card-label {
        font-size: 11.5px;
    }

    .add-amount {
        margin-top: 10px;
    }

    .kuda-searchbox {
        padding: 4px 15px;
    }

    .kuda-dropdown-list {
        padding-top: 48px;
    }

    .kuda-dropdown-item {
        padding: 13px 0 12px !important;
    }

    .payment-wrap .kuda-card--wrap.kuda-bill--wrap {
        padding-left: 57px;
        padding-right: 57px;
    }

    .bill-item,
    .block-item {
        height: 50px;
    }

    .kuda-account--wrap {
        padding: 45px 45px 30px !important;
        min-width: 655px;
    }

    .kuda-invite--cta {
        font-size: 10px;
        height: 20px;
        width: 98px;
    }

    .kuda-header {
        height: 58px;
    }

    .kuda-preview {
        margin-top: 58px;
    }

    .account-title.active:after {
        bottom: -12px;
        height: 3px;
    }

    .referral-icon svg {
        height: 88px;
        width: auto;
    }

    .toggle-icon {
        width: 50px;
        border-radius: 16px;
        height: 28px;
    }

    .toggle-icon:after {
        height: 20px;
        width: 20px;
        top: 4px;
        left: 4px;
    }

    .has-checkBox .toggle {
        top: -4px;
        right: 8px;
    }

    .bill-item--icon svg,
    .block-item--icon svg {
        height: 26px;
    }

    .bill-item--icon {
        margin-right: 15px;
    }

    .block-item--icon {
        margin-right: 10px;
    }

    .account-image {
        width: 85px;
        height: 85px;
        min-width: 85px;
        min-height: 85px;
    }

    .toggle input[type="checkbox"]:checked+.toggle-icon:after {
        transform: translateX(22px);
    }

    .kuda-brand svg {
        height: 16px;
        width: auto;
    }

    .kuda-add--options>* {
        max-width: 300px;
    }

    .kuda-deposit--wrap,
    .kuda-card--wrap {
        max-width: 350px;
        padding-bottom: 38px;
    }

    .accept {
        margin: 38px 0 0;
    }

    .bottom-fix {
        margin-bottom: 30px;
    }

    .kuda-budgeting:not(.category-budget) .transaction-price {
        height: 34px;
    }

    .kuda-budget--filter .DateRangePickerInput {
        height: 44px;
        width: 280px !important;
    }

    .kuda-calendar--control {
        min-height: 44px;
    }

    .plan-budget--wrap {
        max-width: 100%;
    }

    .overview-budget--wrap {
        max-width: 100%;
    }

    footer {
        margin-top: 60px;
    }

    .notice-modal {
        max-width: 390px !important;
    }

    .small-modal .modal-content {
        max-width: 380px;
    }

    .export-modal .modal-content {
        max-width: 455px;
    }

    .kuda-footer--conditions p {
        font-size: 11px;
    }

    footer .container {
        max-width: 1050px;
    }

    .transaction-title {
        margin-left: 20px;
    }

    .kuda-cta-lg {
        max-width: 130px;
    }

    .kuda-tran--items {
        max-width: 172px;
    }

    .kuda-quick--statement svg {
        width: 32px;
        height: 32px;
    }

    .kuda-quick--statement {
        margin-bottom: 4px;
    }

    .balance-icon svg {
        width: 70px;
        height: auto;
    }

    .balance-summary h1.text-xbold.flex {
        position: relative;
        top: -4px;
    }

    .freeTransfer--wrap {
        margin-bottom: 15px;
    }

    .sign-out {
        margin-top: 40px;
    }

    .kuda-cta-long {
        width: 100%;
        max-width: 190px;
    }

    .budget-heading--summary {
        margin-top: 25px;
        margin-bottom: 20px;
    }

    .DateInput_input {
        width: 92px !important;
        padding-left: 9px;
        padding-top: 9px;
    }

    .formCard {
        padding-left: 38px;
        padding-right: 38px;
    }

    .kuda-heading--illustration svg {
        width: 78px;
        height: 78px;
    }

    .kuda-card--wrap {
        margin-top: 30px;
    }

    .denomination,
    .kuda-dropdown-icon {
        width: 38px;
    }

    .transaction-additional--details {
        padding-top: 12px;
        padding-bottom: 12px;
    }

    .generateReceipt {
        max-width: 160px;
    }

    .kuda-history--items .kuda-transaction--tabs {
        height: 37px !important;
        min-height: 37px !important;
    }

    .kuda-header--wrap .kuda-cta {
        font-size: 12.5px;
        height: 40px;
        width: 125px;
    }

    .auth-wrap {
        padding: 50px 70px 30px;
    }

    .kuda-auth--wrap {
        max-width: 345px;
    }

    .kuda-auth--illustration svg {
        max-height: 480px;
    }

    .kuda-savings .kuda-card--wrap,
    .kuda-cards .kuda-card--wrap {
        max-width: 470px;
        padding: 45px 77px;
    }

    .basic-dropdown {
        padding-top: 2px;
    }

    .kuda-page--loader img,
    .kuda-page--loader svg {
        width: 170px !important;
    }

    .kuda-modal-illustration {
        margin: 35px auto 30px;
    }

    .inactivity-buttons .kuda-cta-lg {
        max-width: 135px;
    }

    .modal-transactions .modal-content {
        max-width: 410px;
    }

    .payment-bold--wrap {
        max-width: 220px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

    .forgot-label {
        font-size: 11.5px;
    }

    .kuda-budget--form {
        height: calc(100vh - 405px) !important;
    }

    .budget-heading--summary {
        margin-right: -195px;
        margin-left: -195px;
    }

    .create-budget--button {
        max-width: 185px !important;
    }

    .auth-layout-wrap>div:last-child {
        width: calc(100% - 400px);
    }

    .login-button {
        margin-top: 25px;
    }

    .kuda-login--wrap .formInput {
        font-size: 14px;
    }

    .kuda-login--wrap .formInput {
        padding-top: 12px;
        padding-bottom: 10px;
    }

    .passwordToggle svg {
        height: auto;
        width: 17px;
    }

    .kuda-form--layout {
        margin-top: 25px;
    }

    .payoneer-modal .modal-content {
        max-width: 340px !important;
    }

    .payoneer-modal .generateReceipt {
        max-width: 186px;
    }

    .kuda-add--active .kuda-preview {
        max-width: 800px;
    }

    .product-skeleton .kuda-account--summary:last-child {
        display: none !important;
    }

    .kuda-auth--illustration svg {
        min-width: 650px;
    }

    .kuda-header--wrap .kuda-cta {
        width: 142px;
        max-width: 142px;
    }
}

/* @media only screen and (min-width: 768px) and (max-width: 820px) {
    .kuda-account--wrap {
        margin-left: -58px;
        margin-right: -58px;
    }
} */

@media only screen and (max-height: 730px) {
    .react-datepicker-popper {
        top: 0 !important;
        bottom: 0 !important;
        transform: translate3d(0px, 53px, 0px) !important;
        position: absolute !important;
        -webkit-transform: translate3d(0px, 53px, 0px) !important;
        -moz-transform: translate3d(0px, 53px, 0px) !important;
        -ms-transform: translate3d(0px, 53px, 0px) !important;
        -o-transform: translate3d(0px, 53px, 0px) !important;
    }
}

@media only screen and (min-width: 993px) {
    .kuda-hamburger {
        display: none !important;
    }
}
@media only screen and (max-width: 992px) {
    .kuda-menu--wrap {
        display: none !important;
    }
    .mobile-header--wrap {
        display: flex !important;
    }

    .desktop-header {
        display: none !important;
    }

    .mobile-header--wrap .account-title,
    .mobile-toggle {
        display: flex;
        align-items: center;
    }

    .kuda-mobile--menu {
        position: fixed;
        z-index: 99999;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(64, 25, 109, 0.2);
        
    }

    .kuda-mobile--menu ul.kuda-menu--wrap {
        width: 100%;
        background: #fff;
        display: flex !important;
        height: 100vh;
        flex-direction: column;
        max-width: 0px;
        overflow: hidden;
        margin-left: auto;
        align-items: flex-start !important;
        padding: 6px 22px 22px;
        /* for less modern browsers */
        animation: slide-in-out 0.6s cubic-bezier(0.455, 0.03, 0, 1) forwards;
    }

    @keyframes slide-in-out {
        from {
            max-width: 70px;
            opacity: 0;
        }

        to {
            max-width: 240px;
            opacity: 1;
        }
    }

    .kuda-mobile--menu .kuda-nav--icon {
        width: 100%;
    }

    .kuda-mobile--menu .kuda-nav--icon svg {
        width: 20px;
    }

    .kuda-mobile--menu .kuda-nav--icon a,
    .kuda-mobile--menu .kuda-nav--icon p {
        font-size: 14px !important;
        align-items: center;
        display: flex;
        padding-bottom: 18px;
        padding-top: 18px;
      
    }

    .kuda-mobile--menu .kuda-nav--icon:not(:first-child) a {
        margin-right: 0;
    }

    .kuda-mobile--menu .member-profile {
        width: 20px;
        height: 20px;
    }

}`, "",{"version":3,"sources":["webpack://./src/assets/css/media.css"],"names":[],"mappings":"AAAA;;IAEI;;QAEI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;;;;;QAMI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,YAAY;IAChB;IACA;MACE,UAAU;IACZ;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;QAC5B,2BAA2B;QAC3B,uBAAuB;QACvB,iBAAiB;QACjB,aAAa;QACb,qBAAqB;QAGrB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,WAAW;;IAEf;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;KACC;QACG,2BAA2B;QAC3B,8BAA8B;KACjC;KACA;QACG,cAAc;KACjB;IACD;QACI,SAAS;QACT,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;;;;;QAKI,6BAA6B;QAC7B,8BAA8B;QAC9B,+BAA+B;IACnC;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;;OAEG;IACH;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;;IAGA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,sBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;;QAEI,sBAAsB;QACtB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,8BAA8B;QAC9B,WAAW;QACX,cAAc;IAClB;;IAEA;;QAEI,8BAA8B;QAC9B,WAAW;QACX,cAAc;IAClB;;IAEA;;QAEI,8BAA8B;QAC9B,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,4CAA4C;QAC5C,iCAAiC;QAEjC,2BAA2B;QAE3B,iCAAiC;QAEjC,6BAA6B;QAC7B,yBAAyB;IAC7B;;IAEA;QACI,mCAAmC;QACnC,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;;;;OAKG;IACH;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,2BAA2B;QAC3B,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;QACxB,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,MAAM;IACV;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;;QAEI,uBAAuB;QACvB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,8BAA8B;QAC9B,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,8BAA8B;QAC9B,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,4BAA4B;QAC5B,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;;QAEI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,2BAA2B;QAC3B,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,aAAa;IACjB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;QACZ,aAAa;;IAEjB;IACA;QACI,gDAAgD;QAChD,wDAAwD;QACxD,qDAAqD;QACrD,oDAAoD;QACpD,mDAAmD;IACvD;;;IAGA;;QAEI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB,aAAa;QACb,gBAAgB;QAChB,wBAAwB;QACxB,qBAAqB;QACrB,oBAAoB;QACpB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,8BAA8B;QAC9B,wBAAwB;IAC5B;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;QAC3B,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,sBAAsB;QACtB;IACJ;;IAEA;QACI,eAAe;QACf,+BAA+B;IACnC;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI;IACJ;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI;IACJ;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,mCAAmC;QACnC,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,2BAA2B;QAC3B,mCAAmC;QACnC,gCAAgC;QAChC,+BAA+B;QAC/B,8BAA8B;QAC9B,UAAU;QACV,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,6BAA6B;IACjC;;IAEA;QACI,gCAAgC;QAChC,kCAAkC;QAClC,sBAAsB;IAC1B;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B,oBAAoB;QACpB,sBAAsB;QACtB,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,aAAa;QACb,UAAU;QACV,eAAe;QACf,UAAU;IACd;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,0BAA0B;QAC1B,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,QAAQ;QACR,2BAA2B;QAC3B,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;QAC5B,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;CAEC;IACG;QACI,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,6BAA6B;IACjC;;IAEA;QACI,UAAU;QACV,WAAW;QACX,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;AACA;IACI,gBAAgB;AACpB;AACA;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;QAC5B,2BAA2B;QAC3B,uBAAuB;QACvB,iBAAiB;QACjB,qBAAqB;QAGrB,aAAa;QACb,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,eAAe;QACf,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,eAAe;QACf,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;;;QAGI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;;IAEA;;;;;;;QAOI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;;AAGJ;;AAEA;IACI;SACK,gBAAgB;QACjB,iBAAiB;IACrB;AACJ;AACA;;;;;GAKG;AACH;OACO;SACE,iBAAiB;QAClB,kBAAkB;QAClB,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,eAAe;IACnB;;IAEA;QACI,2BAA2B;QAC3B,mBAAmB;IACvB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,4BAA4B;IAChC;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;;IAEI;;QAEI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,2BAA2B;QAC3B,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,iCAAiC;IACrC;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;QAC3B,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,SAAS;QACT,UAAU;IACd;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;QAChB,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;;OAEG;IACH;QACI,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;;;QAGI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;;QAEI,uBAAuB;QACvB,2BAA2B;IAC/B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,kCAAkC;QAClC,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,SAAS;QACT,UAAU;IACd;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;;;;;GAKG;;AAEH;IACI;QACI,iBAAiB;QACjB,oBAAoB;QACpB,iDAAiD;QACjD,6BAA6B;QAC7B,yDAAyD;QACzD,sDAAsD;QACtD,qDAAqD;QACrD,oDAAoD;IACxD;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,YAAY;QACZ,WAAW;QACX,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,kCAAkC;;IAEtC;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,wBAAwB;QACxB,aAAa;QACb,sBAAsB;QACtB,cAAc;QACd,gBAAgB;QAChB,iBAAiB;QACjB,kCAAkC;QAClC,sBAAsB;QAEtB,6BAA6B;QAC7B,qEAAqE;IACzE;;IAcA;QACI;YACI,eAAe;YACf,UAAU;QACd;;QAEA;YACI,gBAAgB;YAChB,UAAU;QACd;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,0BAA0B;QAC1B,mBAAmB;QACnB,aAAa;QACb,oBAAoB;QACpB,iBAAiB;;IAErB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;AAEJ","sourcesContent":["@media only screen and (max-width: 767px) {\n\n    body,\n    html {\n        font-size: 14px;\n    }\n\n    .personal-form h5 {\n        font-size: 1.28rem;\n    }\n\n    .kuda-preview,\n    .kuda-header--wrap,\n    .kuda-layout---card,\n    .auth-layout--header+.kuda-preview,\n    .auth-wrap,\n    footer .container {\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n\n    .kuda-preview {\n        padding-bottom: 35px;\n    }\n\n    .kuda-header {\n        height: 64px;\n        background: #fff;\n        z-index: 100;\n    }\n    .kuda-header-hidden{\n      z-index: 0;\n    }\n\n    .kuda-preview {\n        display: block;\n        padding-top: 40px;\n    }\n\n    h1 {\n        font-size: 1.6rem;\n    }\n\n    .kuda-cta--table {\n        max-width: 64px;\n        height: 2px;\n        padding-top: 2px;\n        padding-bottom: 2px;\n        width: 3px;\n        font-size: 1px;\n    }\n\n    .kuda-cta--table span {\n        /* max-width: 64px; */\n        font-size: 10px;\n    }\n\n    .kuda-cta {\n        font-size: 14px;\n        height: 48px;\n        width: 100%;\n    }\n\n    .kuda-account--summary .addAction {\n        height: 44px;\n    }\n\n    .kuda-brand svg {\n        height: 16px;\n    }\n\n    .denomination-icon svg {\n        height: 9px;\n        width: auto;\n    }\n\n    .balance-summary {\n        height: 43px;\n        margin-bottom: 1px;\n    }\n\n    .balance-title {\n        margin-top: 0px;\n    }\n\n    .kuda-cta-lg {\n        max-width: 240px;\n    }\n\n    .kuda-cta-long {\n        max-width: 240px;\n    }\n\n    .text-xs {\n        font-size: 0.78rem;\n    }\n\n    .kuda-account--summary .addAction {\n        margin-bottom: 2px;\n    }\n\n    .budget-card {\n        min-height: 76px;\n    }\n\n    .divider {\n        width: auto;\n    }\n\n    .displayWrap>* {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n\n    .kuda-transaction--details {\n        height: 100%;\n    }\n\n    .transaction-name {\n        font-size: 12.3px;\n        line-height: 1.4;\n        display: -webkit-box;\n        -webkit-line-clamp: 1;\n        -webkit-box-orient: vertical;\n        overflow: hidden !important;\n        text-overflow: ellipsis;\n        width: calc(100%);\n        margin-top: 0;\n        -webkit-hyphens: auto;\n        -moz-hyphens: auto;\n        -ms-hyphens: auto;\n        hyphens: auto;\n    }\n\n    .transaction-date {\n        margin-top: 6px;\n    }\n\n    .kuda-transaction--tabs>li {\n        font-size: 12px;\n    }\n\n\n    .auth-layout--header+.kuda-preview {\n        align-items: flex-start;\n    }\n\n    .summary-card {\n        width: 100%;\n    }\n\n    .back svg {\n        margin-right: 6px;\n        height: 11px;\n        position: relative;\n        /* top: -0.55px; */\n    }\n    .kuda-nav--icon-api{\n        margin-top: 19px;\n        margin-bottom: 20px;\n        width: 100%;\n    }\n    .drop-icon{\n        margin-top: 3px;\n    }\n    .drop-icon svg{\n        height: 8px;\n        width: 13px;\n\n    }\n    .api__mobile-menu-wrap{\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        align-items: center;\n    }\n    .api__mobile-menu-text{\n        display: flex;\n        align-items: center;\n    }\n     .api__mobile-menu-text p{\n        padding-top: 0px !important;\n        padding-bottom: 0px !important;\n     }\n     .kuda-nav--icon-api-active p{\n        color: #000000;\n     }\n    .kuda-layout---card .back {\n        top: 25px;\n        left: 20px;\n    }\n\n    .kuda-account {\n        min-width: auto;\n    }\n\n    .account-title {\n        display: none;\n    }\n\n    .kuda-inner--heading {\n        font-size: 1.55rem;\n    }\n\n    .kuda-layout---card {\n        padding-bottom: 30px;\n    }\n\n    .formCard {\n        padding-left: 22px;\n        padding-right: 22px;\n        padding-bottom: 20px;\n    }\n\n    .kuda-deposit--wrap,\n    .kuda-card--wrap,\n    .payment-wrap .kuda-card--wrap,\n    .payment-wrap .kuda-card--wrap.kuda-bill--wrap,\n    .kuda-card--wrap.payment-wrap {\n        padding-left: 22px !important;\n        padding-right: 22px !important;\n        padding-bottom: 40px !important;\n    }\n\n    .request-edge--fix>div {\n        margin-left: -22px;\n        margin-right: -22px;\n        padding-left: 22px;\n        padding-right: 22px;\n    }\n\n    .request-edge--fix .card-text {\n        right: 22px;\n    }\n\n    .sign-out {\n        margin-top: 30px;\n    }\n\n    .kuda-savings .kuda-card--wrap {\n        padding: 40px 22px;\n    }\n\n    .kuda-heading--illustration svg {\n        width: 86px;\n        height: 86px;\n    }\n\n    .percentage-summary {\n        min-height: 46px;\n    }\n\n    .kuda-preview {\n        padding-top: 40px;\n    }\n\n    .kuda-add--cardForm {\n        margin-bottom: 35px !important;\n    }\n\n    .bill-item--icon svg {\n        height: 35px;\n    }\n\n    .bill-item {\n        padding-left: 21px;\n        padding-right: 21px;\n        height: 54px;\n    }\n\n    .kuda-transaction--tabs {\n        overflow-y: hidden;\n        border-radius: 0;\n        overflow-x: scroll;\n        margin-top: 22px;\n    }\n\n    .kuda-payment--tabs li {\n        min-width: 33.33%;\n    }\n\n    .payoneerTab li {\n        min-width: 50%;\n    }\n\n    .percentage-save {\n        height: 64px;\n    }\n\n    .balance.mt-5 {\n        margin-top: 30px !important;\n    }\n\n    .percentage-toggle svg {\n        height: 25px;\n        width: auto;\n    }\n\n    .modal-backdrop {\n        padding: 20px;\n        margin-top: 0px;\n    }\n\n    .modal-content {\n        padding-left: 25px;\n        padding-right: 25px;\n        padding-bottom: 40px;\n    }\n\n    .kuda-cta-md {\n        max-width: 115px;\n    }\n\n    .transaction-title {\n        margin-left: 15px;\n    }\n\n    .viewSavingsSummary .displayWrap>* {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n\n    .viewSavingsSummary .displayWrap>div>* {\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n\n    .kuda-savings--header {\n        margin-bottom: 40px !important;\n    }\n\n    .kuda-card--wrap {\n        margin-top: 25px;\n    }\n\n    .member-profile {\n        margin-right: 11px;\n    }\n\n    .kuda-account--wrap {\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .kuda-account--summary>div,\n    .kuda-block--nav {\n        width: 100%;\n    }\n\n    .kuda-block--navWrapper {\n        flex-direction: column;\n    }\n\n    .block-item {\n        margin-bottom: 15px;\n    }\n\n    .kuda-bills--nav {\n        margin-bottom: -23px;\n    }\n\n    .kuda-account--wrap {\n        margin-left: auto;\n        margin-right: auto;\n        padding-left: 22px !important;\n        padding-right: 22px !important;\n    }\n\n    .kuda-share--earn {\n        margin-top: 30px;\n    }\n\n    .account-image {\n        width: 85px;\n        height: 85px;\n        min-width: 85px;\n        min-height: 85px;\n    }\n\n    .summary-labels {\n        margin-left: 20px;\n    }\n\n    .kuda-invite--cta {\n        font-size: 12px;\n        height: 42px;\n        margin-top: 15px;\n    }\n\n    .profile-account+.kuda-share--earn {\n        margin-top: 33px !important;\n    }\n\n    .kuda-share--earn {\n        padding-left: 21px;\n        padding-right: 21px;\n    }\n\n    .block-item {\n        padding: 10px 21px;\n    }\n\n    .earnings {\n        font-size: 2rem;\n    }\n\n    .inactivity-buttons {\n        flex-direction: column;\n    }\n\n    .inactivity-buttons>div {\n        width: 100%;\n        max-width: 100% !important;\n        margin-bottom: 20px;\n    }\n\n    .transactionSummary .kuda-account--summary {\n        width: auto !important;\n        flex-direction: row;\n    }\n\n    .kuda-share--earn {\n        flex-direction: column-reverse;\n    }\n\n    .kuda-invite--cta,\n    .share-earn--50 {\n        width: 100% !important;\n    }\n\n    .share-earn--50 * {\n        text-align: center !important;\n    }\n\n    .earnings {\n        justify-content: center;\n    }\n\n    .share-earn--50:last-child {\n        margin-bottom: 15px;\n    }\n\n    .earned-amount {\n        font-size: 2.5rem !important;\n    }\n\n    .kuda-account--wrap {\n        padding-top: 80px !important;\n    }\n\n    .kuda-block--navWrapper h1 {\n        text-align: center;\n    }\n\n    .home-account {\n        padding-top: 35px !important;\n    }\n\n    .kuda-split--wrap .card-group {\n        width: 100%;\n    }\n\n    .kuda-split--wrap {\n        flex-direction: column;\n        margin-bottom: 28px;\n    }\n\n    /* .edit-account--wrap {\n        margin-top: 10px\n    } */\n    .back-to {\n        left: 22px;\n    }\n\n    .kuda-cards .kuda-cta-lg {\n        max-width: 100%;\n    }\n\n    .kuda-radio--wrapper {\n        width: calc(50% - 10px);\n    }\n\n    .outer {\n        width: 23px;\n        height: 23px;\n    }\n\n    .inner {\n        width: 11px;\n        height: 11px;\n    }\n\n    .kuda-limit--pad {\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    .limit-fields>div {\n        height: auto;\n        padding-top: 14px;\n        padding-bottom: 14px;\n    }\n\n    .kuda-prev span {\n        line-height: 1.4;\n    }\n\n    .limit-fields .card-type,\n    .limit-fields .card-text {\n        line-height: 1.4;\n    }\n\n    .card-fields>div {\n        align-items: flex-start !important;\n    }\n\n    .kuda-add--money .card-fields>div {\n        align-items: center !important;\n    }\n\n    .panel__label span:first-child {\n        padding-right: 30px;\n    }\n\n    .panel__label span {\n        line-height: 1.45;\n    }\n\n    .kuda-margin--form .edit-account--wrap {\n        margin-top: 0 !important;\n    }\n\n    .accordion {\n        margin-top: 20px !important;\n    }\n\n    .share-header--wrap {\n        flex-direction: column-reverse;\n        margin-top: 0;\n    }\n\n    .share-header--wrap>* {\n        width: 100% !important;\n    }\n\n    .kuda-auth--illustration {\n        display: none !important;\n    }\n\n    .share-enty--text {\n        margin-top: 30px;\n    }\n\n    .share-entry--content {\n        margin-top: 20px;\n    }\n\n    .kuda-transaction--tabs::-webkit-scrollbar {\n        display: none;\n    }\n\n\n    .kuda-account--summary .kuda-cta-lg {\n        max-width: 115px !important;\n    }\n\n    .kuda-account--summary .addAction {\n        margin-bottom: 0 !important;\n    }\n\n    .amount-input {\n        font-size: 16px;\n    }\n\n    .transaction-price {\n        font-size: 13px;\n        margin-right: 12px;\n    }\n\n    .kuda-transaction--details {\n        padding-right: 10px;\n    }\n\n    .kuda-search--field,\n    .kuda-searchbox input {\n        font-size: 16px;\n    }\n\n    .flex.justify-between .kuda-cta-md {\n        max-width: calc(50% - 8px) !important;\n    }\n\n    .flex.justify-between .kuda-cta-lg-sm {\n        max-width: calc(50% - 8px) !important;\n    }\n\n    .kuda-search--bank+.displayResults .kuda-result--item {\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n\n    .card-check {\n        margin-bottom: 35px;\n    }\n\n    .kuda-search--bank+.displayResults .kuda-result--heading {\n        padding-left: 10px;\n    }\n\n    .withdrawButton {\n        max-width: 120px;\n        height: 46px;\n        transform: none !important;\n    }\n\n    .card-fields+.accept {\n        margin-top: 35px;\n    }\n\n    .percentage-save {\n        margin-right: 12px;\n    }\n\n    .single-savings .singleTransaction .transaction-price {\n        top: 4px !important;\n    }\n\n    .goal-actions .kuda-cta:not(:last-child) {\n        margin-right: 15px;\n    }\n\n    .review-summary.card-fields>div {\n        align-items: center !important;\n    }\n\n    .kuda-account--summary {\n        margin-bottom: 30px;\n    }\n\n    .savedCard {\n        width: 100%;\n    }\n\n    .empty-savings--card {\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n\n    .kuda-set--status .addAction {\n        max-width: 120px;\n    }\n\n    .kuda-set--status .addAction {\n        max-width: 120px;\n    }\n\n    .referral-summary .transaction-name {\n        overflow: auto;\n        text-overflow: unset;\n        white-space: normal;\n    }\n\n    .kuda-referral--card .empty-summary {\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    .kuda-referral--card .kuda-transaction--details,\n    .kuda-referral--card .kuda-transaction--details .transaction-title {\n        width: 100% !important;\n        max-width: 100%;\n        padding-right: 0;\n    }\n\n    .kuda-referral--card .kuda-result--heading {\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n\n    .kuda-referral--card .kuda-result--item {\n        width: 100% !important;\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n\n    .skeleton-ui .balance-summary {\n        height: auto;\n    }\n\n    .kuda-home-loader--wrap {\n        margin-bottom: 21px;\n    }\n\n    .loader-30 {\n        width: 50px;\n    }\n\n    .loader-30 span[style*=\"height: 52px\"] {\n        height: 50px !important;\n    }\n\n    .icons--kuda a:not(:last-child),\n    .icons--kuda span:not(:last-child) {\n        margin-right: 10px !important;\n    }\n\n    .socialIcon {\n        margin-right: 10px !important;\n    }\n\n    .icons--kuda span {\n        width: 44px;\n        height: 44px;\n    }\n\n    .pin-input input {\n        font-size: 16px !important;\n    }\n\n    .formInput {\n        font-size: 16px !important;\n    }\n\n    .budget-heading--summary {\n        margin-left: 0;\n        margin-right: 0;\n        margin-bottom: 7px !important;\n    }\n\n    .kuda-budget--filter {\n        flex-wrap: wrap;\n    }\n\n    .date-wrap {\n        width: 100%;\n        margin-bottom: 10px;\n    }\n\n    .filter-field {\n        width: 100%;\n    }\n\n    .budget-heading--summary,\n    .budget-card--header+.budget-heading--summary {\n        margin-right: -20px;\n        margin-left: -20px;\n        overflow-x: scroll;\n        margin-bottom: 20px;\n    }\n\n    .budget-card {\n        min-width: calc(45% - 15px);\n    }\n\n    .budget-cards:before {\n        padding-right: 20px !important;\n        content: \"\";\n        display: block;\n    }\n\n    .budget-cards:after {\n        padding-right: 20px !important;\n        content: \"\";\n        display: block;\n    }\n\n    .category-budget .budget-cards:before,\n    .budget-heading--summary .budget-cards:before {\n        padding-right: 20px !important;\n        content: \"\";\n        display: block;\n    }\n\n    .category-budget .budget-cards:after,\n    .budget-heading--summary .budget-cards:after {\n        padding-right: 20px !important;\n        content: \"\";\n        display: block;\n    }\n\n    .budget-cards::-webkit-scrollbar {\n        display: none;\n    }\n\n    .budget-cards {\n        overflow-y: hidden;\n        -ms-overflow-style: -ms-autohiding-scrollbar;\n        -webkit-overflow-scrolling: touch;\n        -ms-scroll-snap-type: mandatory;\n        scroll-snap-type: mandatory;\n        -ms-scroll-snap-points-y: repeat(50%);\n        scroll-snap-points-y: repeat(50%);\n        -ms-scroll-snap-type: x mandatory;\n        scroll-snap-type: x mandatory;\n        scroll-padding-left: 20px;\n    }\n\n    .budget-cards>* {\n        scroll-snap-align: start !important;\n        scroll-padding-left: 20px;\n    }\n\n    .category-budget .budget-heading--summary {\n        margin-top: 0;\n    }\n\n    .budget-card--semiHeading {\n        font-size: 0.85rem;\n    }\n\n    .budget-card:not(:last-child) {\n        margin-right: 15px;\n    }\n\n    .DateRangePicker,\n    .kuda-budget--filter .DateRangePickerInput {\n        width: 100% !important;\n    }\n\n    .date-wrap .next-calendar--control:last-child {\n        margin-right: 0 !important;\n    }\n\n    /*\n    .DayPicker_portal__horizontal {\n        width: 100%!important;\n        transform: translateX(-50%);\n        margin-left: 0!important;\n    } */\n    .budget-card .card-main--heading {\n        font-size: 1.1rem;\n    }\n\n    .DayPicker_transitionContainer {\n        min-height: 310px;\n    }\n\n    .kuda-budgeting .kuda-result--item {\n        padding-left: 10px !important;\n        padding-right: 10px !important;\n    }\n\n    .kuda-budgeting:not(.category-budget) .transaction-price {\n        height: 32px;\n    }\n\n    .kuda-budgeting:not(.category-budget) .transaction-name {\n        margin-top: -3px;\n        margin-bottom: 0px;\n    }\n\n    .kuda-item--chart .savings-progress {\n        width: calc(100% - 55px);\n    }\n\n    .kuda-budget--excerpt .transaction-price {\n        position: static;\n    }\n\n    .balance-icon {\n        display: none;\n    }\n\n    .kuda-budget--excerpt .transaction-percentage {\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n        bottom: 18px;\n        width: 100%;\n        text-align: left;\n        padding-left: 64px;\n    }\n\n    .kuda-budget--excerpt {\n        padding-bottom: 40px;\n    }\n\n    .budget-heading--summary,\n    .budget-card--header .card-main--heading {\n        margin-top: 25px;\n    }\n\n    .header-icon {\n        display: flex;\n    }\n\n    .budgetTab {\n        margin-top: 0 !important;\n    }\n\n    .budget-heading--summary {\n        -ms-overflow-style: none;\n        scrollbar-width: none;\n    }\n\n    .budget-heading--summary::-webkit-scrollbar {\n        display: none;\n    }\n\n    .budget-cards {\n        padding-bottom: 15px;\n    }\n\n    .DateInput_input {\n        width: 105px !important;\n    }\n\n    .kuda-wrap--wrap--holder>div {\n        width: 100%;\n        margin-bottom: 25px;\n    }\n\n    .kuda-wrap--wrap--holder {\n        flex-wrap: wrap;\n    }\n\n    .kuda-wrap--wrap--holder {\n        flex-wrap: wrap;\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n\n    .history>div {\n        width: 100%;\n    }\n\n    .history {\n        flex-wrap: wrap;\n    }\n\n    .history-text {\n        margin-bottom: 25px;\n    }\n\n    .kuda-history--items .kuda-transaction--tabs {\n        margin-right: 0;\n    }\n\n    .budget-result--holder {\n        margin-top: 26px;\n    }\n\n    .plan-budget--wrap svg.recharts-surface {\n        margin-left: -38px !important;\n        margin-top: -25px;\n    }\n\n    .plan-budget--wrap svg.recharts-surface {\n        min-width: 220px;\n    }\n\n    .plan-budget--wrap .recharts-wrapper {\n        margin-bottom: 20px;\n    }\n\n    .budgetTab+.tabs .kuda-search.kuda-search--bank {\n        margin-top: 0;\n    }\n\n    .create-budget--modal {\n        padding: 0;\n    }\n\n    .create-budget--modal .modal-content {\n        margin: auto;\n        height: auto;\n        border-radius: 0;\n        padding-bottom: 25px;\n        padding-top: 33px;\n    }\n\n    .kuda-budget--form {\n        height: calc(100vh - 306px) !important;\n    }\n\n    .backdrop-init .kuda-entry {\n        overflow: hidden;\n    }\n\n    .edit--budget .kuda-cta {\n        max-width: 100% !important;\n    }\n\n    .kuda-budget--form+.block-buttons {\n        margin-top: 20px !important;\n    }\n\n    .kuda-wrap--wrap--holder:last-child {\n        margin-top: -5px;\n    }\n\n    .kuda-wrap--wrap--holder:last-child {\n        margin-top: -5px;\n    }\n\n    .category-budget .budget-cards:before,\n    .category-budget .budget-cards:after {\n        display: none;\n    }\n\n    .category-budget .budget-cards {\n        margin-top: 25px;\n        margin-bottom: 5px;\n    }\n\n    .edit--budget .kuda-cta:not(:last-child) {\n        margin-right: 20px;\n    }\n\n    .kuda-dayLight--toggle {\n        left: -30px;\n    }\n\n    .kuda-header--actions .kuda-dayLight--toggle {\n        left: -35px;\n    }\n\n    .kuda-tran--items {\n        max-width: 157px;\n    }\n\n    .kuda-tran--items .kuda-quick--statement {\n        margin-bottom: 0;\n    }\n\n    .kuda-quick--statement svg {\n        width: 32px;\n        height: 32px;\n    }\n\n    .budget-create--bg svg {\n        width: 48px;\n        height: auto;\n    }\n\n    .budget-heading {\n        font-size: 0.875rem;\n    }\n\n    .budget-create--bg {\n        position: absolute;\n        left: -18px;\n        bottom: -20px;\n    }\n\n    .percentage-summary {\n        top: 0;\n    }\n\n    .percentage-save {\n        margin-bottom: 0 !important;\n    }\n\n    .kuda-page--loader {\n        margin-left: 30px;\n        margin-bottom: 40%;\n    }\n\n    .kuda-page--loader img,\n    .kuda-page--loader svg {\n        width: 190px !important;\n        height: auto !important;\n        margin-left: 0px;\n    }\n\n    .kuda-404--wrap {\n        padding: 50px 40px 40px;\n    }\n\n    .coming-soon--downloads {\n        flex-wrap: wrap;\n        justify-content: space-between;\n        max-width: 500px;\n    }\n\n    .coming-soon--downloads>* {\n        width: calc(25% - 5px);\n    }\n\n    .coming-soon--downloads>* img {\n        width: 100%;\n        height: auto;\n    }\n\n    .account-skeleton .balance {\n        margin-bottom: 20px;\n    }\n\n    .account-skeleton .balance-second--half {\n        display: block;\n    }\n\n    .account-skeleton .kuda-account--summary {\n        margin-bottom: 20px;\n        flex-direction: column;\n    }\n\n    .account-skel--items .kuda-skeleton-span:last-child {\n        display: none;\n    }\n\n    .kuda-footer--conditions p {\n        font-size: 10.5px;\n    }\n\n    .category-budget .budget-heading--summary>div:after {\n        padding-right: 20px !important;\n        content: \"\";\n        display: block;\n    }\n\n    .category-budget .budget-heading--summary>div:before {\n        padding-left: 0px !important;\n        content: \"\";\n        display: block;\n    }\n\n    .account-skeleton .balance-icon {\n        display: block !important;\n        width: 65px;\n        height: 65px;\n        min-width: 65px;\n    }\n\n    .account-skeleton .balance.skeleton-ui>div:last-child span {\n        width: 80% !important;\n    }\n\n    .denomination-icon {\n        margin-right: 2px;\n    }\n\n    .kuda-header--wrap .kuda-cta {\n        font-size: 14px;\n        height: 42px;\n        width: 150px;\n    }\n\n    .banks-ussd {\n        margin-top: 28px;\n        padding-bottom: 22px;\n    }\n\n    .kuda-form--ussd {\n        margin-bottom: 0;\n    }\n\n    .addCard-skeleton {\n        padding-top: 5px;\n    }\n\n    .plan-margin {\n        margin-top: 8px;\n    }\n\n    .account-skeleton .balance {\n        display: none !important;\n    }\n\n    .kuda-share--earnAlt {\n        margin-top: 20px;\n    }\n\n    .share-header--wrap .kuda-share--earn {\n        padding-bottom: 25px !important;\n    }\n\n    .linked-active {\n        padding-bottom: 35px !important;\n    }\n\n    .add-product--wrap {\n        margin-top: 10px;\n    }\n\n    .savedCards {\n        margin-top: 10px;\n    }\n\n    .kuda-referral--card .edit-account--wrap {\n        margin-top: 0;\n    }\n\n    .kuda-balance--wrap {\n        width: 100%;\n        min-height: 100%;\n    }\n\n    .payoneer-heading {\n        margin-top: 30px;\n        margin-bottom: 27px;\n    }\n\n    .revoke-content .kuda-modal-illustration svg,\n    .kuda-budget--illustration svg {\n        width: 65px !important;\n        height: 65px !important;\n    }\n\n    .product-skeleton .kuda-account--summary>div {\n        width: 100% !important;\n    }\n\n    .product-skeleton .kuda-account--summary {\n        margin-bottom: 20px;\n    }\n\n    .savedCard {\n        margin-bottom: 20px;\n    }\n\n    .kuda-share--earn {\n        margin-top: 20px;\n    }\n\n    .addCard-skeleton {\n        padding-top: 25px;\n    }\n\n    .kuda-account--wrap {\n        padding-bottom: 25px !important;\n    }\n\n    .budget-card--header+.budget-heading--summary {\n        margin-bottom: 0px !important;\n    }\n\n    .share-header--wrap .kuda-share--earn {\n        padding-bottom: 30px !important;\n    }\n\n    .share-header--wrap .kuda-share--earnAlt {\n        padding-bottom: 27px !important;\n    }\n\n    .justify-center.inactivity-buttons>div {\n        max-width: 200px !important;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .kuda-announcement--card,\n    .kuda-login--header {\n        padding: 14px 20px;\n    }\n\n    .error-auth--label {\n        padding: 12px 15px;\n    }\n\n    .auth-layout--header+.kuda-preview {\n        min-height: calc(100vh - 88px) !important;\n    }\n\n    .kuda-page--transition .kuda-preview {\n        min-height: calc(100vh - 80px);\n    }\n\n    .no-result {\n        padding: 15px 5px 10px;\n    }\n\n    .request-wrap .kuda-cta-lg,\n    .saveFields {\n        max-width: 210px !important;\n    }\n\n    .saveFields {\n        margin-top: 43px;\n    }\n\n    .back-to+.edit-account--wrap {\n        margin-top: 0;\n    }\n\n    .linked-active .kuda-cta-lg {\n        max-width: 175px;\n    }\n\n    .personal-form .login-button.kuda-cta-md {\n        max-width: 170px !important;\n    }\n\n    .overdraftResults {\n        margin-left: -22px;\n        margin-right: -22px;\n    }\n\n    .overdraftResults>div>* {\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n\n    .modal-overdraft .modal-content {\n        max-width: 100% !important;\n        height: 100vh;\n    }\n\n    .modal-overdraft .kuda-budget--form {\n        height: calc(100vh - 170px) !important;\n    }\n\n    .backArrow {\n        display: flex;\n    }\n\n    .backArrow svg {\n        transform: translateY(-0.9px);\n    }\n\n    .card {\n        width: 100px;\n        height: 156px;\n    }\n\n    .active-card .card {\n        transform: translate3d(-50px, 0, 0);\n    }\n\n    .active-card .card-secret-details {\n        transform: translateX(0px);\n    }\n\n    .physical-card .flippy svg {\n        width: 120px;\n        height: 180px;\n\n    }\n    .active-card .flippy {\n        transform: rotateY(-180deg) translate3d(0, 0, 0);\n        -webkit-transform: rotateY(-180deg) translate3d(0, 0, 0);\n        -moz-transform: rotateY(-180deg) translate3d(0, 0, 0);\n        -ms-transform: rotateY(-180deg) translate3d(0, 0, 0);\n        -o-transform: rotateY(-180deg) translate3d(0, 0, 0);\n    }\n\n\n    .card-animation--wrap,\n    .physical-card>svg {\n        height: 156px;\n    }\n\n    .new-card--illustration svg {\n        max-width: 135px;\n        height: auto;\n    }\n\n    .flex.justify-between>.kuda-cta-lg-md {\n        width: calc(50% - 8px);\n    }\n\n    .upload-is--two {\n        flex-direction: column;\n    }\n\n    .upload-item-md {\n        width: 100% !important;\n        max-width: 100%;\n    }\n\n    .modal-terms .kuda-radio--wrapper {\n        width: 100%\n    }\n\n    .modal-terms .modal-content {\n        max-height: calc(100vh);\n        padding: 20px;\n        border-radius: 0;\n        -webkit-border-radius: 0;\n        -moz-border-radius: 0;\n        -ms-border-radius: 0;\n        -o-border-radius: 0;\n        max-width: 100%;\n    }\n\n    .kuda-terms--wrap {\n        max-height: calc(100vh - 394px);\n    }\n\n    .form-group-row {\n        flex-direction: column;\n    }\n\n    .form-group-row .card-group {\n        width: 100%;\n    }\n\n    .form-group-row .card-group {\n        margin-bottom: 22px !important;\n        margin-top: 0 !important;\n    }\n\n    .form-group-row.mt-4 {\n        margin-top: 0 !important\n    }\n\n    .form-fields {\n        margin-top: 22px;\n    }\n\n    .mt-4.column--100 {\n        margin-top: 0 !important;\n    }\n\n    .card-group {\n        margin-bottom: 22px;\n    }\n\n    .card-group.mt-4 {\n        margin-top: 0 !important;\n    }\n\n    .card-group .card-group {\n        margin-bottom: 0 !important;\n    }\n\n    .onboarding-info--wrap>.mt-5:not(.justify-center) {\n        margin-top: 1rem !important;\n    }\n\n    .block-item-wrap {\n        padding-right: 10px;\n    }\n\n    .auth-header--full {\n        max-width: 260px !important;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .bank-has--multiple---items .kuda-search {\n        width: 100%;\n        max-width: 100%;\n        width: 100% !important;\n        margin-bottom: 15px\n    }\n\n    .bank-has--multiple---items .tabs>.flex {\n        flex-wrap: wrap;\n        margin-bottom: -10px !important;\n    }\n\n    .toggleIcon {\n        margin: 0\n    }\n\n    .toggleIcon:not(:last-child) {\n        margin-right: 13px;\n    }\n\n    .toggleIcon {\n        height: 48px;\n        width: calc(33.33% - 41px)\n    }\n\n    .profile-account {\n        margin-top: 35px;\n    }\n\n    .kuda-profile--center>.profile-account {\n        margin-top: 0 !important;\n    }\n\n    .transaction-result--item,\n    .kuda-result--heading {\n        padding-left: 10px !important;\n        padding-right: 10px !important;\n    }\n\n    .other-items--wrap>.toggleIcon {\n        width: 100%;\n    }\n\n    .other-items--wrap {\n        width: 100%;\n        overflow-x: scroll;\n        padding-bottom: 10px;\n        margin-bottom: 12px;\n    }\n\n    .onboarding-info--wrap .flex-wrap.flex {\n        flex-direction: column;\n    }\n\n    .kuda-tiny--button {\n        min-width: 50px;\n    }\n\n    .column--50 {\n        width: 100%;\n    }\n\n    .kin-wrap .form-group-row.mt-4 {\n        margin-top: 23px !important;\n    }\n\n    .card-display--bio {\n        padding: 15px 20px !important;\n    }\n\n    .onboarding-info--wrap .flex-wrap.flex>.column--50 {\n        margin-bottom: 10px;\n        margin-top: 0 !important;\n    }\n\n    .has-bottom--spacing {\n        margin-bottom: 20px;\n    }\n\n    .mobile-input>.card-group {\n        margin-bottom: 0;\n    }\n\n    .kuda-login--wrap>*+.auth-wrap,\n    .kuda-started--container *+.kuda-login--wrap .auth-wrap {\n        padding-top: 80px\n    }\n\n    .block-item-sm .add-signatory--wrap.block-item {\n        width: 100% !important;\n        max-width: 175px;\n    }\n\n    .auth-wrap .empty-summary {\n        margin-top: 0;\n    }\n\n    .kuda-started--container .kuda-auth--layout {\n        margin-top: 0\n    }\n\n    .kuda-announcement--card h1 {\n        font-size: 2.2rem !important;\n    }\n\n    .kuda-login--header {\n        padding-top: 0 !important;\n    }\n\n    .tr.table-row--border td:nth-child(1),\n    table.kuda-signatory--table thead tr th:nth-child(1) {\n        min-width: 260px;\n    }\n\n    .tr.table-row--border td:nth-child(2),\n    table.kuda-signatory--table thead tr th:nth-child(2) {\n        min-width: 152px;\n    }\n\n    .tr.table-row--border td:nth-child(3),\n    table.kuda-signatory--table thead tr th:nth-child(3) {\n        min-width: 152px;\n    }\n\n    .tr.table-row--border td:nth-child(4),\n    table.kuda-signatory--table thead tr th:nth-child(4) {\n        min-width: 120px;\n    }\n\n    .request-payment {\n        display: block;\n        min-width: 190px;\n        max-width: 190px;\n        width: 190px;\n    }\n\n    .kuda-payment--item---wrap>* {\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n\n    .kuda-payment--item---wrap.overflow-x-scroll div.kuda-result--heading {\n        width: fit-content;\n    }\n\n    .sme-m-info--card {\n        flex-direction: column;\n    }\n\n    .sme-m-info--card>ul {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .sme-m-info--card>ul:last-of-type {\n        margin-bottom: 0;\n    }\n\n    .sme-info--card .vertical-divider {\n        width: 100%;\n        height: 1px;\n        background-color: var(--blackColor);\n        margin: 0 0 20px 0;\n    }\n\n    .document-is--sided {\n        margin-top: 40px;\n        flex-direction: column;\n        margin-right: 0;\n    }\n\n    .document-is--sided>div {\n        width: 100%;\n        margin-right: 0;\n    }\n\n    .inline-sample--wrap:before {\n        left: 50%;\n        transform: translateX(-50%);\n        -webkit-transform: translateX(-50%);\n        -moz-transform: translateX(-50%);\n        -ms-transform: translateX(-50%);\n        -o-transform: translateX(-50%);\n        width: 1px;\n        height: 2rem;\n        top: calc(-2rem - 1px);\n    }\n\n    .company-mini-profile {\n        flex-direction: column;\n        margin-bottom: 0px !important;\n    }\n\n    .company-mini-info {\n        margin-bottom: 1.5rem !important;\n        align-items: flex-start !important;\n        width: 100% !important;\n    }\n\n    .summary-labels-mb {\n        margin-top: 15px\n    }\n\n    .business-img-file-input {\n        position: absolute !important;\n        top: 70px !important;\n        left: 120px !important;\n        right: 0;\n        bottom: 0;\n        width: 100px;\n        height: 100px;\n        opacity: 0;\n        cursor: pointer;\n        z-index: 9;\n    }\n\n    .mobile-mt-4 {\n        margin-top: 23px !important;\n    }\n\n    .edit-to {\n        position: absolute;\n        font-size: 12px;\n        display: flex;\n        align-items: center;\n        top: 25px;\n        right: 0px !important;\n        cursor: pointer;\n    }\n\n    .kuda-terms--tab {\n        margin-left: 0 !important;\n        margin-right: 0 !important\n    }\n\n    .edit-moreOptions--wrap .kuda-select--radio {\n        height: 44px;\n    }\n\n    .modal-terms {\n        padding: 0 !important;\n    }\n\n    .content-wrap {\n        padding-bottom: 20px;\n    }\n\n    .kuda-get--app .kuda-signup--wrap {\n        margin: 0 auto;\n        padding: 0 !important;\n    }\n\n    .kuda-get--app {\n        transform: none !important;\n        margin-top: 0;\n        padding-top: 40px;\n    }\n\n    .kuda-get--app.align-center {\n        align-items: flex-start !important;\n    }\n\n    .kuda-get--app .kuda-signup--wrap .kuda-signup--right {\n        display: none;\n    }\n\n    .kuda-signup--left {\n        padding: 40px 30px 45px;\n    }\n\n    .kuda-signup--left * {\n        text-align: center;\n        justify-content: center;\n    }\n\n    .c-apps+div {\n        margin-top: 13px !important;\n    }\n\n    .kuda-reports--radio {\n        flex-direction: column;\n    }\n\n    .kuda-reports--radio .radio-height--md {\n        width: 100%;\n        max-width: 100%;\n    }\n\n    .export-modal .modal-content {\n        padding-left: 25px;\n        padding-right: 25px;\n        padding-bottom: 40px;\n    }\n\n    .kuda-reports--radio .radio-height--md.mr-3 {\n        margin-bottom: 15px;\n    }\n\n    .header-bottom--spacing {\n        margin-bottom: 23px\n    }\n\n    .kuda-preview {\n        margin-top: 64px;\n    }\n\n    .restricted-account--wrap {\n        padding: 20px;\n        position: relative;\n        overflow: hidden;\n    }\n\n    .restricted-account--wrap .restricted-image--wrap {\n        position: absolute;\n        right: -180px;\n        top: 50%;\n        transform: translateY(-50%);\n        display: flex;\n        align-items: center;\n    }\n\n    .restricted-account--wrap .restricted-text {\n        padding-bottom: 0 !important;\n        padding-right: 72px;\n    }\n    .tr.table-row--border td:nth-child(1),.bulk-payment table.kuda-signatory--table thead tr th:nth-child(1) {\n        min-width: fit-content;\n    }\n    .overflow-x-scroll-mobile {\n        overflow-x: scroll;\n    }\n}\n\n@media only screen and (max-width: 1153px){\n    .kuda-nav--icon a{\n        margin-right: 25px;\n    }\n}\n\n@media only screen and (max-width: 375px) {\n    .kuda-header--wrap .kuda-cta {\n        font-size: 13px;\n        width: 140px;\n    }\n\n    .kuda-header--actions .kuda-dayLight--toggle {\n        left: -33px;\n    }\n\n    .phoneInput {\n        font-size: 16px !important;\n    }\n}\n\n @media only screen and (max-width: 320px) {\n    .kuda-header--wrap .kuda-cta {\n        font-size: 12px;\n        width: 131px;\n        margin-top: 15px;\n    }\n\n    .auth-layout--header {\n        height: 110px;\n    }\n\n    .auth-layout--header .kuda-header--wrap {\n        flex-direction: column;\n        align-items: start !important;\n    }\n\n    .auth-layout--header .kuda-header--actions .kuda-dayLight--toggle {\n        left: auto;\n        right: 20px;\n        top: 17px;\n    }\n\n    .auth-layout--header .kuda-header--actions {\n        position: static;\n    }\n\n    .auth-layout--header+.kuda-preview {\n        margin-top: 115px;\n    }\n\n    .auth-layout--header+.kuda-preview {\n        min-height: calc(100vh - 135px) !important;\n    }\n\n    .kuda-header--actions {\n        width: 100%;\n    }\n\n    .kuda-header--wrap .kuda-cta {\n        max-width: 100%;\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 924px) {\n    html {\n        font-size: 14.5px;\n    }\n\n    .kuda-nav--icon a,\n    .kuda-nav--icon p {\n        margin-right: 34px;\n    }\n\n    .kuda-nav--icon svg {\n        width: 19px;\n    }\n\n    .kuda-dayLight--toggle svg {\n        width: 18px;\n    }\n\n    .kuda-dayLight--toggle {\n        left: -30px;\n    }\n\n    .kuda-header--wrap,\n    footer .container {\n        padding-left: 40px;\n        padding-right: 40px;\n    }\n\n    .kuda-brand svg {\n        height: 18px;\n        width: auto;\n    }\n\n    .kuda-payments .card-summary-text p {\n        font-size: 15px;\n    }\n\n    .percentage-save {\n        margin-right: 12px;\n    }\n\n    .kuda-skeleton-span+.budget-heading--summary {\n        margin-bottom: 45px;\n    }\n}\n\n@media only screen and (max-width: 1136px){\n.kuda-started--container {\n    max-width: 700px;\n}\n}\n@media only screen and (max-width: 923px){\n    .kuda-nav--icon a{\n        margin-right: 25px;\n    }\n}\n\n@media only screen and (max-width: 575px) {\n    .kuda-transaction--tabs {\n        overflow-y: hidden;\n        margin-left: -20px;\n        margin-right: -20px;\n    }\n\n    .account-skeleton span.mb-2.bottom>span>span {\n        width: 100% !important;\n    }\n\n    .account-skeleton span.mb-2.bottom {\n        width: 100%;\n    }\n\n    .account-skeleton .balance-summary {\n        width: 100%;\n    }\n\n    .budget-heading--summary .category-budget--highlighted .card-main--heading {\n        line-height: 1.4;\n        position: relative;\n        top: -2px;\n    }\n\n    .budget-card .card-main--heading {\n        font-size: 1rem;\n    }\n\n    .kuda-auth--illustration {\n        display: none;\n    }\n\n    .kuda-auth--wrap {\n        max-width: 100%;\n    }\n\n    .block-item--icon {\n        display: none !important;\n    }\n\n    .kuda-payment--tabs li {\n        min-width: 30% !important;\n    }\n\n    .signup-form--wrap {\n        max-width: 100%;\n        width: 100%;\n        flex-direction: column;\n    }\n\n    .auth-wrap {\n        flex-direction: column;\n    }\n\n    .account-setup--right {\n        display: none;\n    }\n\n    .login-container--wrap {\n        background-size: auto !important;\n    }\n}\n\n@media only screen and (min-width: 768px) {\n    .kuda-header{\n        display: none !important;\n    }\n\n    .kuda-auth--illustration svg {\n        min-width: 700px;\n    }\n\n    .kuda-search--bank+.displayResults .displayWrap>* {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n\n    .kuda-search--bank+.displayResults .kuda-result--item {\n        padding-left: 30px;\n        padding-right: 30px;\n    }\n\n    .kuda-search--bank+.displayResults .kuda-result--heading {\n        padding-left: 31px;\n    }\n\n    .transaction-left {\n        padding-right: 15px;\n    }\n\n    .account-title.active {\n        position: relative;\n    }\n\n    .account-title.active:after {\n        content: \"\";\n        display: block;\n        height: 5px;\n        bottom: 0px;\n        position: absolute;\n        background: #000000;\n        width: 100%;\n    }\n\n    .earnings {\n        line-height: 1;\n        margin-top: 8px;\n        margin-bottom: -7px;\n    }\n\n    .transaction-name {\n        display: -webkit-box;\n        -webkit-line-clamp: 1;\n        -webkit-box-orient: vertical;\n        overflow: hidden !important;\n        text-overflow: ellipsis;\n        width: calc(100%);\n        -webkit-hyphens: auto;\n        -moz-hyphens: auto;\n        -ms-hyphens: auto;\n        hyphens: auto;\n        padding-right: 40px;\n        line-height: 1.2;\n    }\n\n    .no-bottom--margin-desktop {\n        margin-bottom: 0 !important;\n    }\n\n    .skeleton-card--top .kuda-card--wrap {\n        padding-bottom: 57px !important;\n    }\n\n    .plan-margin {\n        margin-top: 8px;\n    }\n\n    .kuda-add--active .kuda-preview {\n        max-width: 959px;\n    }\n\n    .kuda-add--active .kuda-add--options {\n        display: flex;\n        justify-content: center;\n        flex-wrap: wrap;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .kuda-add--active .kuda-add--options>* {\n        width: calc(50% - 10px);\n        max-width: 100%;\n        margin-right: 0;\n        margin-left: 0;\n    }\n\n    .account-image {\n        margin-top: -4px;\n    }\n\n    .kuda-signup--wrap {\n        max-height: 605px;\n    }\n\n    .kuda-started--container .react-datepicker-popper {\n        z-index: 99 !important;\n        min-width: 360px;\n    }\n\n    .kuda-started--container .onboarding-info--wrap .react-datepicker__day-name,\n    .kuda-started--container .onboarding-info--wrap .react-datepicker__day,\n    .kuda-started--container .onboarding-info--wrap .react-datepicker__time-name {\n        width: 12% !important;\n    }\n\n    .upload-is--two .upload-item {\n        width: calc(50% - 8px);\n        max-width: 100%;\n    }\n\n    .upload-is--two {\n        justify-content: space-between;\n    }\n\n    .mt-4-md {\n        margin-top: 1.5rem;\n    }\n\n    .mobile-input>.card-group {\n        margin-bottom: 0;\n    }\n\n    .document-is--sided .mt-4.flex.justify-center {\n        margin-top: 0 !important;\n    }\n\n    .document-is--sided .upload-item {\n        margin-top: 20px;\n    }\n\n    .inventory-search-toggle--icon {\n        margin-top: 23px !important;\n    }\n\n    .form-group-row .card-group .react-datepicker,\n    .form-group-row .card-group .react-datepicker__month-container {\n        min-width: 340px;\n        max-width: 340px;\n    }\n}\n\n@media only screen and (max-width: 1200px) {\n    .auth-layout-wrap>div:last-child {\n        width: calc(100% - 420px);\n    }\n\n    .auth-layout--header+.kuda-preview {\n        min-height: calc(100vh - 100px);\n    }\n}\n\n@media only screen and (max-width: 320px) {\n\n    html,\n    body {\n        font-size: 13px;\n    }\n\n    .kuda-preview,\n    .kuda-header--wrap,\n    .kuda-layout---card,\n    .auth-layout--header+.kuda-preview,\n    .auth-wrap,\n    .modal-content,\n    footer .container {\n        padding-left: 14px;\n        padding-right: 14px;\n    }\n\n    .kuda-cta {\n        font-size: 13px;\n        height: 44px;\n    }\n\n    .kuda-transaction--details {\n        padding-right: 10px;\n    }\n\n    .single-savings .transaction-name {\n        padding-right: 10px;\n    }\n\n    .summary-card {\n        padding: 20px 15px 32px;\n    }\n\n    .modal-content {\n        padding-top: 25px;\n        padding-bottom: 25px;\n    }\n\n    .kuda-budget--form {\n        height: calc(100vh - 298px) !important;\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n    .kuda-account--wrap {\n        max-width: 100%;\n        padding: 40px 30px !important;\n    }\n\n    .kuda-block--nav {\n        width: calc(50% - 10px);\n    }\n\n    .earn-heading {\n        font-size: 0.875rem;\n    }\n\n    .earnings {\n        margin-bottom: 3px;\n    }\n\n    .balance:not(.home-skel) .balance.skeleton-ui>div:last-child span {\n        width: 100% !important;\n    }\n\n    .balance:not(.home-skel) .balance.skeleton-ui>div:last-child {\n        width: 100% !important;\n    }\n\n    .kuda-add--active .kuda-layout---card {\n        padding-left: 30px !important;\n        padding-right: 30px !important;\n    }\n\n\n}\n\n@media only screen and (min-width: 768px){\n    .kuda-account--wrap {\n         margin-left: 0px;\n        margin-right: 0px;\n    }\n}\n/* @media only screen and (min-width: 858px){\n       .kuda-account--wrap {\n         margin-left: -65px;\n        margin-right: -65px;\n    }\n} */\n@media only screen and (min-width: 1150px){\n       .kuda-account--wrap {\n         margin-left: auto;\n        margin-right: auto;\n        margin-top: 48px;\n    }\n}\n@media only screen and (max-height: 760px) {\n    .modal-backdrop {\n        /* display: block; */\n        overflow-y: auto;\n    }\n\n    .modal>.modal {\n        display: flex;\n    }\n\n    .modal-backdrop .modal-content {\n        margin: auto;\n    }\n}\n\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n    .kuda-auth--illustration svg {\n        min-width: 700px;\n    }\n\n    .auth-layout-wrap>div:last-child {\n        width: calc(100% - 530px);\n    }\n}\n\n@media only screen and (min-width: 1025px) and (max-width: 1199px) {\n    .budget-heading--summary {\n        margin-right: -140px !important;\n        margin-left: -140px !important;\n    }\n\n    .budget-heading--summary .card-main--heading {\n        font-size: 1.15rem !important;\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n    .kuda-auth--illustration {\n        display: none;\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n    .budget-heading--summary {\n        margin-right: -70px !important;\n        margin-left: -70px !important;\n        flex-wrap: wrap;\n    }\n\n    .budget-card {\n        min-width: calc(25% - 20px);\n        margin-bottom: 20px;\n    }\n\n    .budget-cards {\n        margin-bottom: -20px !important;\n    }\n\n    .budget-skeleton .budget-cards {\n        margin-bottom: 0px;\n    }\n\n    .budget-card:not(:last-child) {\n        margin-right: 12px;\n    }\n\n    .budget-card {\n        min-height: 100%;\n    }\n\n    .budget-card--semiHeading {\n        font-size: 0.8rem;\n    }\n\n    .card-main--heading {\n        font-size: 1.1rem;\n    }\n\n    .kuda-budget--filter .DateRangePickerInput {\n        width: 308px !important;\n    }\n\n    .kuda-wrap--wrap--holder>div {\n        width: 100%;\n    }\n\n    .kuda-wrap--wrap--holder>div:not(:last-child) {\n        margin-bottom: 25px;\n    }\n}\n\n@media only screen and (max-width: 375px) {\n    .budget-card {\n        min-width: calc(70% - 15px);\n    }\n}\n\n@media only screen and (max-width: 400px) {\n    .DateInput_input {\n        width: 100% !important;\n    }\n\n    .DateInput_input {\n        padding-left: 5px;\n        font-size: 0.9rem !important;\n    }\n}\n\n@media only screen and (max-width: 375px) {\n\n    body,\n    html {\n        font-size: 13px;\n    }\n\n    .balance-summary {\n        height: 41px;\n    }\n}\n\n@media only screen and (max-height: 800px) and (min-width: 1025px) and (max-width: 1366px) {\n\n    html,\n    body {\n        font-size: 14.8px;\n    }\n\n    .kuda-preview {\n        padding: 48px 40px 60px;\n    }\n\n    .balance-title {\n        margin-top: 6px;\n    }\n\n    .kuda-transaction--tabs {\n        margin-top: 30px;\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .invoice-f-col {\n        min-width: 300px !important;\n        max-width: 300px !important;\n        width: 300px !important;\n    }\n}\n\n@media only screen and (max-width: 409px) {\n    .homeSkel {\n        width: calc(50% - 7px) !important;\n    }\n\n    .homeSkel .balance-summary {\n        width: 100%;\n    }\n\n    .homeSkel .balance-summary span,\n    .homeSkel+span span {\n        width: 100% !important;\n    }\n\n    .homeSkel .balance-summary>span:first-child {\n        width: 65% !important;\n    }\n\n    .homeSkel+span {\n        width: calc(50% - 7px) !important;\n    }\n}\n\n@media only screen and (max-width: 350px) {\n    .kuda-cta {\n        font-size: 13px;\n        height: 46px;\n    }\n\n    h1 {\n        font-size: 1.4rem;\n    }\n\n    .denomination-icon svg {\n        height: 8px;\n        width: auto;\n    }\n\n    .balance-summary {\n        height: 39px;\n    }\n\n    .kuda-quick--statement svg {\n        width: 30px;\n        height: 30px;\n        margin-right: 6px;\n    }\n\n    .kuda-account--summary .kuda-cta-lg {\n        max-width: 105px !important;\n        min-width: 105px !important;\n    }\n\n    .kuda-tran--items {\n        max-width: 142px;\n    }\n\n    .balance-summary {\n        margin-bottom: 3px;\n    }\n\n    .kuda-header--wrap .kuda-cta {\n        font-size: 13px;\n        height: 42px;\n        width: 100%;\n    }\n}\n\n@media only screen and (max-height: 798px) and (min-width: 1140px) {\n    .kuda-cta {\n        font-size: 15px;\n    }\n\n    .kuda-cta-md {\n        max-width: 150px;\n    }\n}\n\n@media only screen and (min-height: 799px) and (min-width: 768px) {\n    .kuda-auth--illustration svg {\n        min-width: 820px;\n    }\n\n    .justify-between>.kuda-cta-md {\n        max-width: 150px;\n    }\n}\n\n@media only screen and (min-height: 799px) and (min-width: 768px) and (max-width: 1280px) {\n    .kuda-auth--illustration svg {\n        min-width: 750px;\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1300px) {\n    .kuda-auth--wrap {\n        max-width: 410px;\n        width: 100%;\n    }\n\n    .auth-wrap {\n        padding: 50px 70px 30px;\n    }\n\n    .kuda-form--layout {\n        margin-top: 25px;\n    }\n\n    .kuda-auth--wrap p {\n        font-size: 0.9rem;\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1300px) and (min-height: 799px) {\n    .auth-layout-wrap>div:last-child {\n        width: calc(100% - 475px);\n    }\n\n    .edit-moreOptions--wrap .kuda-select--radio {\n        height: 44px;\n    }\n\n    .kuda-select--radio {\n        margin-top: 15px;\n    }\n\n    .kuda-terms--wrap {\n        max-height: calc(100vh - 508px);\n    }\n\n    .modal-terms .modal-content {\n        max-height: calc(100vh - 80px);\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1440px) and (max-height: 798px) {\n    .container {\n        max-width: 720px;\n    }\n\n    .payments-container {\n        max-width: 850px;\n    }\n\n    .kuda-signup--container {\n        max-width: 957px !important;\n    }\n\n    .modal-content {\n        padding: 35px 48px 48px;\n    }\n\n    html,\n    body {\n        font-size: 14px !important;\n    }\n\n    .fund-card--modal .modal-content {\n        max-width: 410px;\n    }\n\n    .kuda-cta {\n        font-size: 14px;\n        height: 45px;\n    }\n\n    .kuda-header--wrap .kuda-cta {\n        font-size: 13.5px;\n        height: 43px;\n    }\n\n    .kuda-result--item {\n        padding-top: 15px;\n        padding-bottom: 15px;\n    }\n\n    .kuda-search--field,\n    .kuda-transaction--tabs {\n        height: 47px !important;\n    }\n\n    .kuda-terms--tab {\n        height: 25px !important;\n        min-height: 35px;\n    }\n\n    .kuda-transaction--details {\n        height: 37px;\n    }\n\n    .transaction-icon {\n        width: 40px;\n        height: 40px;\n        min-width: 40px;\n    }\n\n    .kuda-nav--icon svg {\n        width: 23px;\n    }\n\n    .kuda-preview {\n        padding: 48px 40px 60px;\n    }\n\n    .balance-title {\n        margin-top: 6px;\n    }\n\n    .kuda-transaction--tabs {\n        margin-top: 30px;\n    }\n\n    .kuda-account--summary {\n        margin-bottom: 30px;\n    }\n\n    .budgetTab {\n        margin-top: 0;\n    }\n\n    .payment-wrap .kuda-card--wrap {\n        max-width: 480px;\n    }\n\n    .amount-input {\n        min-height: 44px;\n    }\n\n    .card-group:not(:last-child) {\n        margin-bottom: 24px;\n    }\n\n    .kuda-dropdown-header {\n        height: 44px;\n    }\n\n    .kuda-add--cardForm {\n        margin-bottom: 44px;\n    }\n\n    .card-label {\n        font-size: 13px;\n    }\n\n    .add-amount {\n        margin-top: 10px;\n    }\n\n    .kuda-searchbox {\n        padding: 4px 15px;\n    }\n\n    .kuda-dropdown-list {\n        padding-top: 48px;\n    }\n\n    .kuda-dropdown-item {\n        padding: 13px 0 12px !important;\n    }\n\n    .payment-wrap .kuda-card--wrap.kuda-bill--wrap {\n        padding-left: 65px;\n        padding-right: 65px;\n    }\n\n    .bill-item,\n    .block-item {\n        height: 52px;\n    }\n\n    .kuda-account--wrap {\n        padding: 45px 62px 40px !important;\n    }\n\n    .kuda-invite--cta {\n        font-size: 11px;\n        height: 20px;\n    }\n\n    .kuda-header {\n        height: 65px;\n    }\n\n    .kuda-preview {\n        margin-top: 65px;\n    }\n\n    .account-title.active:after {\n        bottom: -15px;\n    }\n\n    .referral-icon svg {\n        height: 88px;\n        width: auto;\n    }\n\n    .toggle-icon {\n        width: 50px;\n        border-radius: 16px;\n        height: 28px;\n    }\n\n    .toggle-icon:after {\n        height: 20px;\n        width: 20px;\n        top: 4px;\n        left: 4px;\n    }\n\n    .has-checkBox .toggle {\n        top: -4px;\n        right: 8px;\n    }\n\n    .bill-item--icon svg,\n    .block-item--icon svg {\n        height: 28px;\n    }\n\n    .bill-item--icon {\n        margin-right: 15px;\n    }\n\n    .block-item--icon {\n        margin-right: 10px;\n    }\n\n    .account-image {\n        width: 85px;\n        height: 85px;\n        min-width: 85px;\n        min-height: 85px;\n    }\n\n    .toggle input[type=\"checkbox\"]:checked+.toggle-icon:after {\n        transform: translateX(22px);\n    }\n\n    .kuda-brand svg {\n        height: 18px;\n        width: auto;\n    }\n\n    .kuda-add--options>* {\n        max-width: 330px;\n    }\n\n    .kuda-deposit--wrap,\n    .kuda-card--wrap {\n        max-width: 380px;\n    }\n\n    .accept {\n        margin: 38px 0 0;\n    }\n\n    .bottom-fix {\n        margin-bottom: 30px;\n    }\n\n    .kuda-budgeting:not(.category-budget) .transaction-price {\n        height: 34px;\n    }\n\n    .kuda-budget--filter .DateRangePickerInput {\n        height: 46px;\n    }\n\n    .kuda-calendar--control {\n        min-height: 46px;\n    }\n\n    .plan-budget--wrap {\n        max-width: 100%;\n    }\n\n    .overview-budget--wrap {\n        max-width: 100%;\n    }\n\n    footer {\n        margin-top: 60px;\n    }\n\n    .notice-modal {\n        max-width: 390px !important;\n    }\n\n    .small-modal .modal-content {\n        max-width: 410px;\n    }\n\n    .export-modal .modal-content {\n        max-width: 485px;\n    }\n\n    .kuda-footer--conditions p {\n        font-size: 10.5px;\n    }\n\n    footer .container {\n        max-width: 1050px;\n    }\n\n    .inactivity-buttons .kuda-cta-lg {\n        max-width: 146px;\n    }\n\n    .kuda-auth--wrap {\n        max-width: 370px;\n    }\n\n    .auth-layout-wrap>div:last-child {\n        width: calc(100% - 450px);\n    }\n\n    .auth-wrap {\n        padding: 50px 70px 30px;\n    }\n\n    .basic-dropdown {\n        padding-top: 2px;\n    }\n\n    .kuda-page--loader img,\n    .kuda-page--loader svg {\n        width: 190px !important;\n    }\n\n    .kuda-modal-illustration {\n        margin: 35px auto 30px;\n    }\n\n    .modal-transactions .modal-content {\n        max-width: 470px;\n    }\n\n    .payment-bold--wrap {\n        max-width: 240px;\n    }\n\n    .forgot-label {\n        font-size: 11.5px;\n    }\n\n    .single-timeline {\n        margin-bottom: 40px;\n    }\n\n    .kuda-cta-lg {\n        max-width: 142px;\n    }\n\n    .kuda-tran--items {\n        max-width: 192px;\n    }\n\n    .balance-summary h1.text-xbold.flex {\n        position: relative;\n        top: -2px;\n    }\n\n    .kuda-login--wrap .formInput {\n        font-size: 14.5px;\n    }\n\n    .kuda-home-loader--wrap:last-child {\n        display: none;\n    }\n\n    .create-budget--modal .modal-content {\n        height: calc(100vh - 115px);\n    }\n\n    .create-budget--modal .modal-content {\n        max-width: 550px !important;\n    }\n\n    .kuda-budget--form {\n        height: calc(100vh - 420px) !important;\n    }\n\n    .create-budget--modal .createBalance {\n        height: 40px;\n    }\n\n    .create-budget--modal .kuda-result--heading {\n        margin-top: 25px;\n    }\n\n    .kuda-budget--filter .DateRangePickerInput {\n        width: 300px !important;\n    }\n\n    .filter-field {\n        width: calc(100% - 251px);\n    }\n\n    .DateInput_input {\n        width: 103px !important;\n        padding-left: 9px;\n        padding-top: 9px;\n    }\n\n    .CalendarMonth_caption {\n        padding-top: 17px;\n    }\n\n    .budget-heading--summary {\n        margin-right: -195px;\n        margin-left: -195px;\n    }\n\n    .create-budget--button {\n        max-width: 170px !important;\n    }\n\n    .form-loading:after {\n        width: 27px;\n        height: 27px;\n        background-size: 27px 27px;\n    }\n\n    .inputLoading:after {\n        width: 24px;\n        height: 24px;\n        background-size: 24px 24px;\n    }\n\n    .skeleton-card--top .kuda-activate--wrap {\n        max-width: 420px;\n        padding-left: 50px !important;\n        padding-right: 50px !important;\n    }\n\n    .payoneer-modal .modal-content {\n        max-width: 380px !important;\n    }\n\n    .kuda-balance--wrap .add-icon {\n        margin-bottom: 9px;\n    }\n\n    .kuda-balance--wrap {\n        min-height: 140px;\n    }\n\n    .payoneer-modal-heading {\n        margin-top: 1.7rem;\n        margin-bottom: 1.7rem;\n    }\n\n    .payoneer-modal .generateReceipt {\n        max-width: 195px;\n    }\n\n    .kuda-add--active .kuda-preview {\n        max-width: 860px;\n    }\n\n    .closeModal svg {\n        height: 24px;\n    }\n\n    /* .closeModal {\n        top: -18px;\n    } */\n    .payoneer-heading {\n        max-width: 315px;\n        margin-top: 30px;\n        margin-bottom: 30px;\n    }\n\n    .kuda-cta-long {\n        width: 100%;\n        max-width: 208px;\n    }\n\n    .kuda-dropdown-list {\n        max-height: 320px;\n    }\n\n    .kuda-cta-xl {\n        max-width: 210px;\n    }\n\n    .product-skeleton .kuda-account--summary {\n        margin-bottom: 20px;\n    }\n\n    .kuda-auth--wrap p {\n        font-size: 0.845rem;\n    }\n\n    .kuda-auth--illustration svg {\n        max-height: 520px;\n    }\n\n    .kuda-header--wrap .kuda-cta {\n        width: 158px;\n        max-width: 158px;\n    }\n\n    .edit-moreOptions--wrap .kuda-select--radio {\n        height: 44px;\n    }\n\n    .kuda-select--radio {\n        margin-top: 15px;\n    }\n\n    .kuda-terms--wrap {\n        max-height: calc(100vh - 485px);\n    }\n\n    .modal-terms .modal-content {\n        max-height: calc(100vh - 80px);\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1280px) and (max-height: 698px) {\n    .container {\n        max-width: 640px;\n    }\n\n    .transaction-header {\n        margin-top: 25px;\n        margin-bottom: 15px;\n    }\n\n    .modal-content {\n        padding: 30px 43px 43px;\n    }\n\n    html,\n    body {\n        font-size: 12.5px !important;\n    }\n\n    .fund-card--modal .modal-content {\n        max-width: 390px;\n    }\n\n    .kuda-cta {\n        font-size: 12.5px;\n        height: 42px;\n    }\n\n    .formCard,\n    .kuda-deposit--wrap,\n    .kuda-card--wrap {\n        max-width: 330px;\n    }\n\n    .kuda-result--item {\n        padding-top: 14px;\n        padding-bottom: 14px;\n    }\n\n    .kuda-search--field,\n    .kuda-transaction--tabs {\n        height: 44px !important;\n        min-height: 44px !important;\n    }\n\n    .kuda-transaction--details {\n        height: 33px;\n    }\n\n    .transaction-icon {\n        width: 40px;\n        height: 40px;\n        min-width: 40px;\n    }\n\n    .kuda-nav--icon svg {\n        width: 20px;\n    }\n\n    .kuda-preview {\n        padding: 40px 40px 55px;\n    }\n\n    .balance-title {\n        margin-top: 8px;\n    }\n\n    .kuda-transaction--tabs {\n        margin-top: 30px;\n    }\n\n    .kuda-account--summary {\n        margin-bottom: 30px;\n    }\n\n    .budgetTab {\n        margin-top: 0;\n    }\n\n    .payment-wrap .kuda-card--wrap {\n        margin-top: 30px;\n        padding-left: 46px;\n        max-width: 420px;\n        padding-right: 46px;\n        padding-bottom: 36px;\n    }\n\n    .amount-input {\n        min-height: 40px;\n    }\n\n    .card-group:not(:last-child) {\n        margin-bottom: 24px;\n    }\n\n    .kuda-dropdown-header {\n        height: 40px;\n    }\n\n    .kuda-add--cardForm {\n        margin-bottom: 40px;\n    }\n\n    .card-label {\n        font-size: 11.5px;\n    }\n\n    .add-amount {\n        margin-top: 10px;\n    }\n\n    .kuda-searchbox {\n        padding: 4px 15px;\n    }\n\n    .kuda-dropdown-list {\n        padding-top: 48px;\n    }\n\n    .kuda-dropdown-item {\n        padding: 13px 0 12px !important;\n    }\n\n    .payment-wrap .kuda-card--wrap.kuda-bill--wrap {\n        padding-left: 57px;\n        padding-right: 57px;\n    }\n\n    .bill-item,\n    .block-item {\n        height: 50px;\n    }\n\n    .kuda-account--wrap {\n        padding: 45px 45px 30px !important;\n        min-width: 655px;\n    }\n\n    .kuda-invite--cta {\n        font-size: 10px;\n        height: 20px;\n        width: 98px;\n    }\n\n    .kuda-header {\n        height: 58px;\n    }\n\n    .kuda-preview {\n        margin-top: 58px;\n    }\n\n    .account-title.active:after {\n        bottom: -12px;\n        height: 3px;\n    }\n\n    .referral-icon svg {\n        height: 88px;\n        width: auto;\n    }\n\n    .toggle-icon {\n        width: 50px;\n        border-radius: 16px;\n        height: 28px;\n    }\n\n    .toggle-icon:after {\n        height: 20px;\n        width: 20px;\n        top: 4px;\n        left: 4px;\n    }\n\n    .has-checkBox .toggle {\n        top: -4px;\n        right: 8px;\n    }\n\n    .bill-item--icon svg,\n    .block-item--icon svg {\n        height: 26px;\n    }\n\n    .bill-item--icon {\n        margin-right: 15px;\n    }\n\n    .block-item--icon {\n        margin-right: 10px;\n    }\n\n    .account-image {\n        width: 85px;\n        height: 85px;\n        min-width: 85px;\n        min-height: 85px;\n    }\n\n    .toggle input[type=\"checkbox\"]:checked+.toggle-icon:after {\n        transform: translateX(22px);\n    }\n\n    .kuda-brand svg {\n        height: 16px;\n        width: auto;\n    }\n\n    .kuda-add--options>* {\n        max-width: 300px;\n    }\n\n    .kuda-deposit--wrap,\n    .kuda-card--wrap {\n        max-width: 350px;\n        padding-bottom: 38px;\n    }\n\n    .accept {\n        margin: 38px 0 0;\n    }\n\n    .bottom-fix {\n        margin-bottom: 30px;\n    }\n\n    .kuda-budgeting:not(.category-budget) .transaction-price {\n        height: 34px;\n    }\n\n    .kuda-budget--filter .DateRangePickerInput {\n        height: 44px;\n        width: 280px !important;\n    }\n\n    .kuda-calendar--control {\n        min-height: 44px;\n    }\n\n    .plan-budget--wrap {\n        max-width: 100%;\n    }\n\n    .overview-budget--wrap {\n        max-width: 100%;\n    }\n\n    footer {\n        margin-top: 60px;\n    }\n\n    .notice-modal {\n        max-width: 390px !important;\n    }\n\n    .small-modal .modal-content {\n        max-width: 380px;\n    }\n\n    .export-modal .modal-content {\n        max-width: 455px;\n    }\n\n    .kuda-footer--conditions p {\n        font-size: 11px;\n    }\n\n    footer .container {\n        max-width: 1050px;\n    }\n\n    .transaction-title {\n        margin-left: 20px;\n    }\n\n    .kuda-cta-lg {\n        max-width: 130px;\n    }\n\n    .kuda-tran--items {\n        max-width: 172px;\n    }\n\n    .kuda-quick--statement svg {\n        width: 32px;\n        height: 32px;\n    }\n\n    .kuda-quick--statement {\n        margin-bottom: 4px;\n    }\n\n    .balance-icon svg {\n        width: 70px;\n        height: auto;\n    }\n\n    .balance-summary h1.text-xbold.flex {\n        position: relative;\n        top: -4px;\n    }\n\n    .freeTransfer--wrap {\n        margin-bottom: 15px;\n    }\n\n    .sign-out {\n        margin-top: 40px;\n    }\n\n    .kuda-cta-long {\n        width: 100%;\n        max-width: 190px;\n    }\n\n    .budget-heading--summary {\n        margin-top: 25px;\n        margin-bottom: 20px;\n    }\n\n    .DateInput_input {\n        width: 92px !important;\n        padding-left: 9px;\n        padding-top: 9px;\n    }\n\n    .formCard {\n        padding-left: 38px;\n        padding-right: 38px;\n    }\n\n    .kuda-heading--illustration svg {\n        width: 78px;\n        height: 78px;\n    }\n\n    .kuda-card--wrap {\n        margin-top: 30px;\n    }\n\n    .denomination,\n    .kuda-dropdown-icon {\n        width: 38px;\n    }\n\n    .transaction-additional--details {\n        padding-top: 12px;\n        padding-bottom: 12px;\n    }\n\n    .generateReceipt {\n        max-width: 160px;\n    }\n\n    .kuda-history--items .kuda-transaction--tabs {\n        height: 37px !important;\n        min-height: 37px !important;\n    }\n\n    .kuda-header--wrap .kuda-cta {\n        font-size: 12.5px;\n        height: 40px;\n        width: 125px;\n    }\n\n    .auth-wrap {\n        padding: 50px 70px 30px;\n    }\n\n    .kuda-auth--wrap {\n        max-width: 345px;\n    }\n\n    .kuda-auth--illustration svg {\n        max-height: 480px;\n    }\n\n    .kuda-savings .kuda-card--wrap,\n    .kuda-cards .kuda-card--wrap {\n        max-width: 470px;\n        padding: 45px 77px;\n    }\n\n    .basic-dropdown {\n        padding-top: 2px;\n    }\n\n    .kuda-page--loader img,\n    .kuda-page--loader svg {\n        width: 170px !important;\n    }\n\n    .kuda-modal-illustration {\n        margin: 35px auto 30px;\n    }\n\n    .inactivity-buttons .kuda-cta-lg {\n        max-width: 135px;\n    }\n\n    .modal-transactions .modal-content {\n        max-width: 410px;\n    }\n\n    .payment-bold--wrap {\n        max-width: 220px;\n        display: block;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .forgot-label {\n        font-size: 11.5px;\n    }\n\n    .kuda-budget--form {\n        height: calc(100vh - 405px) !important;\n    }\n\n    .budget-heading--summary {\n        margin-right: -195px;\n        margin-left: -195px;\n    }\n\n    .create-budget--button {\n        max-width: 185px !important;\n    }\n\n    .auth-layout-wrap>div:last-child {\n        width: calc(100% - 400px);\n    }\n\n    .login-button {\n        margin-top: 25px;\n    }\n\n    .kuda-login--wrap .formInput {\n        font-size: 14px;\n    }\n\n    .kuda-login--wrap .formInput {\n        padding-top: 12px;\n        padding-bottom: 10px;\n    }\n\n    .passwordToggle svg {\n        height: auto;\n        width: 17px;\n    }\n\n    .kuda-form--layout {\n        margin-top: 25px;\n    }\n\n    .payoneer-modal .modal-content {\n        max-width: 340px !important;\n    }\n\n    .payoneer-modal .generateReceipt {\n        max-width: 186px;\n    }\n\n    .kuda-add--active .kuda-preview {\n        max-width: 800px;\n    }\n\n    .product-skeleton .kuda-account--summary:last-child {\n        display: none !important;\n    }\n\n    .kuda-auth--illustration svg {\n        min-width: 650px;\n    }\n\n    .kuda-header--wrap .kuda-cta {\n        width: 142px;\n        max-width: 142px;\n    }\n}\n\n/* @media only screen and (min-width: 768px) and (max-width: 820px) {\n    .kuda-account--wrap {\n        margin-left: -58px;\n        margin-right: -58px;\n    }\n} */\n\n@media only screen and (max-height: 730px) {\n    .react-datepicker-popper {\n        top: 0 !important;\n        bottom: 0 !important;\n        transform: translate3d(0px, 53px, 0px) !important;\n        position: absolute !important;\n        -webkit-transform: translate3d(0px, 53px, 0px) !important;\n        -moz-transform: translate3d(0px, 53px, 0px) !important;\n        -ms-transform: translate3d(0px, 53px, 0px) !important;\n        -o-transform: translate3d(0px, 53px, 0px) !important;\n    }\n}\n\n@media only screen and (min-width: 993px) {\n    .kuda-hamburger {\n        display: none !important;\n    }\n}\n@media only screen and (max-width: 992px) {\n    .kuda-menu--wrap {\n        display: none !important;\n    }\n    .mobile-header--wrap {\n        display: flex !important;\n    }\n\n    .desktop-header {\n        display: none !important;\n    }\n\n    .mobile-header--wrap .account-title,\n    .mobile-toggle {\n        display: flex;\n        align-items: center;\n    }\n\n    .kuda-mobile--menu {\n        position: fixed;\n        z-index: 99999;\n        height: 100%;\n        width: 100%;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: rgba(64, 25, 109, 0.2);\n        \n    }\n\n    .kuda-mobile--menu ul.kuda-menu--wrap {\n        width: 100%;\n        background: #fff;\n        display: flex !important;\n        height: 100vh;\n        flex-direction: column;\n        max-width: 0px;\n        overflow: hidden;\n        margin-left: auto;\n        align-items: flex-start !important;\n        padding: 6px 22px 22px;\n        -webkit-animation: slide-in-out 0.6s cubic-bezier(0.455, 0.03, 0, 1) forwards;\n        /* for less modern browsers */\n        animation: slide-in-out 0.6s cubic-bezier(0.455, 0.03, 0, 1) forwards;\n    }\n\n    @-webkit-keyframes slide-in-out {\n        from {\n            max-width: 70px;\n            opacity: 0;\n        }\n\n        to {\n            max-width: 240px;\n            opacity: 1;\n        }\n    }\n\n    @keyframes slide-in-out {\n        from {\n            max-width: 70px;\n            opacity: 0;\n        }\n\n        to {\n            max-width: 240px;\n            opacity: 1;\n        }\n    }\n\n    .kuda-mobile--menu .kuda-nav--icon {\n        width: 100%;\n    }\n\n    .kuda-mobile--menu .kuda-nav--icon svg {\n        width: 20px;\n    }\n\n    .kuda-mobile--menu .kuda-nav--icon a,\n    .kuda-mobile--menu .kuda-nav--icon p {\n        font-size: 14px !important;\n        align-items: center;\n        display: flex;\n        padding-bottom: 18px;\n        padding-top: 18px;\n      \n    }\n\n    .kuda-mobile--menu .kuda-nav--icon:not(:first-child) a {\n        margin-right: 0;\n    }\n\n    .kuda-mobile--menu .member-profile {\n        width: 20px;\n        height: 20px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
